<template>
  <div class="page-anniversary">
    <!-- 活动标题 -->
    <div v-wechat-title="'尼克镇长，庆典筹备就靠你了！'"></div>
    <div class="home-wrapper" :class="isPC ? 'ispc' : ''">
      <div class="main-container" id="main-container">
        <!-- 加载页 -->
        <div v-show="enterLoading" class="loading-page">
          <div class="loading-content">
            <h1 class="game-title">
              阿瑞斯病毒2
            </h1>
            <p class="loading-text">正在前往希望镇镇庆现场 {{ progress }}%</p>
          </div>
        </div>
        <!-- 序章黑幕 -->
        <IntroOverlay :visible="showIntro" @finished="onIntroFinished" />
        <div ref="gameContainer" id="gameContainer" class="gameContainer" style="width: 100%; height: 100%;">
          <div class="area-box weapon-box" :class="getLevelStageClass(4)" @click="onHandleAreaClick(4)">
            <div class="income-box">
              <span>{{ formatIncome4 }}</span>
            </div>
            <div class="btn-level-up" @click.stop="onHandleLevelUpClick(4)">
              <svg viewBox="0 0 100 100">
                <path d="M 0 50 a 50 50 0 1 1 0 1 z" id="circle" fill="none" stroke="transparent"></path>
                <text font-weight="bold" fill="#fff" font-size="22" dy="-4">
                  <textPath xlink:href="#circle">
                    {{ getLevelStageClass(4, true) }}
                  </textPath>
                </text>
              </svg>
            </div>
          </div>
          <div class="area-box car-box" :class="getLevelStageClass(5)" @click="onHandleAreaClick(5)">
            <div class="income-box">
              <span>{{ formatIncome5 }}</span>
            </div>
            <div class="btn-level-up" @click.stop="onHandleLevelUpClick(5)">
              <svg viewBox="0 0 100 100">
                <path d="M 0 50 a 50 50 0 1 1 0 1 z" id="circle" fill="none" stroke="transparent"></path>
                <text font-weight="bold" fill="#fff" font-size="22" dy="-4">
                  <textPath xlink:href="#circle">
                    {{ getLevelStageClass(5, true) }}
                  </textPath>
                </text>
              </svg>
            </div>
          </div>
          <div class="area-box camp-box" :class="getLevelStageClass(2)" @click="onHandleAreaClick(2)">
            <div class="income-box">
              <span>{{ formatIncome2 }}</span>
            </div>
            <div class="btn-level-up" @click.stop="onHandleLevelUpClick(2)">
              <svg viewBox="0 0 100 100">
                <path d="M 0 50 a 50 50 0 1 1 0 1 z" id="circle" fill="none" stroke="transparent"></path>
                <text font-weight="bold" fill="#fff" font-size="22" dy="-4">
                  <textPath xlink:href="#circle">
                    {{ getLevelStageClass(2, true) }}
                  </textPath>
                </text>
              </svg>
            </div>
          </div>
          <div class="area-box dinner-box" :class="getLevelStageClass(3)" @click="onHandleAreaClick(3)">
            <div class="income-box">
              <span>{{ formatIncome3 }}</span>
            </div>
            <div class="btn-level-up" @click.stop="onHandleLevelUpClick(3)">
              <svg viewBox="0 0 100 100">
                <path d="M 0 50 a 50 50 0 1 1 0 1 z" id="circle" fill="none" stroke="transparent"></path>
                <text font-weight="bold" fill="#fff" font-size="22" dy="-4">
                  <textPath xlink:href="#circle">
                    {{ getLevelStageClass(3, true) }}
                  </textPath>
                </text>
              </svg>
            </div>
          </div>
          <div class="area-box dance-box" :class="getLevelStageClass(1)" @click="onHandleAreaClick(1)">
            <div class="income-box">
              <span>{{ formatIncome1 }}</span>
            </div>
            <div class="btn-level-up" @click.stop="onHandleLevelUpClick(1)">
              <svg viewBox="0 0 100 100">
                <path d="M 0 50 a 50 50 0 1 1 0 1 z" id="circle" fill="none" stroke="transparent"></path>
                <text font-weight="bold" fill="#fff" font-size="22" dy="-4">
                  <textPath xlink:href="#circle">
                    {{ getLevelStageClass(1, true) }}
                  </textPath>
                </text>
              </svg>
            </div>
          </div>
          <div class="fire-box" :class="user_activity.story_progress && user_activity.story_progress.find((item) => item.id === 6).status === 2 ? 'cake' : ''"></div>
          <!-- 每个 NPC 区块 -->
          <div v-for="npc in npcList" :key="npc.id" :class="['npc-avatar', npc.class]" @click="handleNpcAvatarClick(npc.id)" :style="{ zIndex: npc.id === currentNpcId ? 5 : 4 }">
            <!-- 台词气泡 -->
            <div v-if="currentNpcId === npc.id" class="npc-bubble">
              {{ currentLine }}
            </div>
          </div>
        </div>
        <!-- 飞行动画层 -->
        <div id="coin-layer"></div>
        <div>
          <div class="left-top-box">
            <div class="img-avatar"></div>
            <div class="info-box">
              <div class="speed_produce info-item">
                <img src="https://download4.qcplay.com/h5-images/active/ares/anniversary/img_rate.png" />
                <span class="speed_produce-text">{{ `${user_activity.speed_produce || 0}/秒` }}</span>
              </div>
              <div class="gold_coin info-item">
                <img src="https://download4.qcplay.com/h5-images/active/ares/anniversary/img_small_mucai.png" />
                <span class="gold_coin-text">{{user_activity.gold_coin || 0}}</span>
              </div>
              <div class="draw_number info-item">
                <img src="https://download4.qcplay.com/h5-images/active/ares/anniversary/img_small_draw.png" />
                <span class="draw_number-text">{{user_activity.draw_number || 0}}</span></div>
            </div>
          </div>
          <div class="right-top-btns">
            <div class="btns-box">
              <div class="btn-share" @click="onHandleShareClick"></div>
              <div class="btn-config" @click="onHandleConfigClick"></div>
              <div class="btn-detail" @click="onHandleDetailClick"></div>
            </div>
            <div class="btn-draw" @click="onHandleDrawClick"></div>
          </div>
          <div class="right-bottom-btns">
            <div class="btn-get" @click="onHandleGetClick"></div>
            <div class="btn-undo" :class="user_activity.task_list && user_activity.task_list.find((item) => item.status === 1) ? 'tip' : ''" @click="onHandleUndoClick"></div>
          </div>
          <div class="baoji-box" :class="`rate-${user_activity.crit_rate}`" @click="buffShow = true;logger.sum('周年庆_暴击卡点击');"></div>
          <div class="left-bottom-btn">
            <div class="btn-story" :class="user_activity.story_progress && user_activity.story_progress.find((item) => item.status === 1) ? 'tip' : ''" @click="onHandlestoryClick"></div>
          </div>
        </div>
        <!-- 登录中间页弹窗 -->
        <div class="login-middle-wrap popup_wrap1" v-show="loginMiddleShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="login-middle-box popup_wrap-box" v-show="loginMiddleShow">
              <div class="btn-id-login" @click="changeLoginPopup(true);playClickMusic();"></div>
            </div>
          </transition>
        </div>
        <!-- 建筑解锁弹窗 -->
        <div class="building-unlock-wrap popup_wrap1" v-show="showUnlockModal">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="building-unlock-box popup_wrap-box" v-show="showUnlockModal">
              <div class="help-detail-box">
                <div class="left-avatar" :class="`avatar-${building_id}`"></div>
                <div class="info-box">
                  <div class="area-name">{{ areaName[building_id] }}</div>
                  <div class="helper-label"></div>
                  <div class="helper-name">{{ helpName[building_id] }}</div>
                  <div class="buff1" v-if="user_activity.crit_rate === 50"></div>
                  <div class="buff2" v-if="user_activity.crit_rate === 200"></div>
                </div>
                <div class="right-box">
                  <div class="next_produce">+{{ currentBuilding.next_produce }}/秒</div>
                </div>
              </div>
              <div class="btn-confirm-unlock" @click="onHandleLevelUp(1, 'unlock')" :class="currentBuilding.unlock ? '' : 'no-unlock'">
                <div class="up-materials">{{ currentBuilding.up_materials }}</div>
              </div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="showUnlockModal = false"></div>
        </div>
        <!-- 建筑升级弹窗 -->
        <div class="building-level-up-wrap popup_wrap1" v-show="showLevelUpModal">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="building-level-up-box popup_wrap-box" v-show="showLevelUpModal">
              <div class="help-detail-box">
                <div class="left-avatar" :class="`avatar-${building_id}`"></div>
                <div class="info-box">
                  <div class="area-name">{{ areaName[building_id] }}</div>
                  <div class="helper-label"></div>
                  <div class="helper-name">{{ helpName[building_id] }}</div>
                  <div class="buff1" v-if="user_activity.crit_rate === 50"></div>
                  <div class="buff2" v-if="user_activity.crit_rate === 200"></div>
                </div>
                <div class="right-box">
                  <div class="level">{{ currentBuilding.level }}</div>
                  <div class="produce">+{{ currentBuilding.five_next_produce }}/秒</div>
                  <div class="next_produce">+{{ currentBuilding.next_produce }}/秒</div>
                </div>
              </div>
              <div class="btns">
                <div class="btn-confirm-up1" @click="onHandleLevelUp(1, 'level-up')" :class="currentBuilding.unlock ? '' : 'no-unlock'">
                  <div class="up-materials">{{ currentBuilding.up_materials }}</div>
                </div>
                <div class="btn-confirm-up2" @click="onHandleLevelUp(5, 'level-up')" :class="currentBuilding.five_unlock ? '' : 'no-unlock'">
                  <div class="up-materials">{{ currentBuilding.five_up }}</div>
                </div>
              </div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="showLevelUpModal = false"></div>
        </div>
        <!-- 抽奖弹窗 -->
        <div class="draw-wrap popup_wrap1" v-show="drawShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="draw-box popup_wrap-box" v-show="drawShow">
              <div class="btn-close" @click="drawShow = false;playClickMusic();"></div>
              <div class="right-box">
                <div class="draw-left-box">
                  <div class="img-choujiangquan"></div>
                  <div class="draw-num">{{ user_activity.draw_number }}</div>
                </div>
                <div class="btn-draw-record" @click="drawRecordShow = true;playClickMusic();logger.sum('周年庆_抽奖领奖中心')"></div>
                <div class="btn-detail" @click="detailShow = true;playClickMusic();logger.sum('周年庆_抽奖活动说明')"></div>
              </div>
              <div class="addup-box">
                <div class="addup-content">
                  <div class="level-box">
                    <div v-for="(item, index) in cumulative_progress" :key="index" :class="{
                        [`level-item level-${item.id} status-${item.status}`]: true,
                        get: cumulative_draw >= item.level_limit,
                      }" @click="onGetDrawTotalClick(item)">
                    </div>
                    <div class="bg-line"></div>
                  </div>
                </div>
                <div class="draw-total-box">
                  <span class="total-label"></span>
                  <span class="total-text">{{ cumulative_draw }}</span>
                </div>
              </div>
              <!-- 弹幕播报 -->
              <div class="notice-bar" v-if="notice.length">
                <transition name="notice-slide" mode="out-in">
                  <div class="notice-text" :key="keySeed">
                    恭喜玩家{{notice[currentNoticeIndex].role_name}}抽到<span class="reward-name">【{{ notice[currentNoticeIndex].name }}】</span>,欧气满满!
                  </div>
                </transition>
              </div>
              <div class="wheel-wrapper">
                <!-- 彩灯层（动画层） -->
                <img v-show="spinning" class="wheel-lamp lamp-on" :class="{ 'lamp-flicker': spinning }" src="https://download4.qcplay.com/h5-images/active/ares/anniversary/lamp_on.png" alt="" />
                <img class="wheel-lamp lamp-off" src="https://download4.qcplay.com/h5-images/active/ares/anniversary/lamp_off.png" alt="" />
                <img class="wheel-bg" src="https://download4.qcplay.com/h5-images/active/ares/anniversary/zhuanpan.png" alt="" />
                <img class="wheel-pointer" src="https://download4.qcplay.com/h5-images/active/ares/anniversary/zhizhen.png" :style="{ transform: 'translate(-50%, -50%) rotate(' + angle + 'deg)' }" alt="">
                <!-- 奖励点击区域（点击扇区） -->
                <svg class="wheel-svg" viewBox="0 0 612 612" xmlns="http://www.w3.org/2000/svg">
                  <g v-for="(item, index) in 9" :key="index" class="sector" @click="showRewardDetail(index)">
                    <path :d="getSectorPath(index, 9, 220)" fill="transparent" stroke="transparent" />
                  </g>
                </svg>
              </div>
              <div class="btn-draw-one" :class="user_activity.judge_draw ? '' : 'lock'" @click="startDraw">
              </div>
            </div>
          </transition>
        </div>
        <!-- 抽奖结果弹窗 -->
        <div class="draw-result-wrap popup_wrap1" v-show="drawResultShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="draw-result-box popup_wrap-box" :class="`big-${drawResultId}`" v-show="drawResultShow">
              <div class="content" :class="`result${drawResultId}`">
              </div>
              <div class="btn-result-close" @click="handleDrawResultClose"></div>
            </div>
          </transition>
        </div>
        <!-- 活动说明弹窗 -->
        <div class="detail-wrap popup_wrap1" v-show="detailShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="detail-box popup_wrap-box" v-if="detailShow">
              <div class="content">
                <img class="img-detail" src="https://download4.qcplay.com/h5-images/active/ares/anniversary/detail.png" alt="" />
              </div>
              <div class="detail-icon"></div>
              <div class="btn-top-close" @click="detailShow = false"></div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="detailShow = false"></div>
        </div>
        <!-- 抽奖-领奖中心记录 -->
        <div class="draw-record-wrap popup_wrap1" v-show="drawRecordShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="draw-record-box popup_wrap-box" v-show="drawRecordShow">
              <div class="no-record" v-if="!user_activity.record || !user_activity.record.draw_record.length"></div>
              <div v-else class="content-box">
                <div class="content">
                  <div v-for="(item, index) in (user_activity.record && user_activity.record.draw_record || [])" :key="index" :class="`record-item status${item.status}`">
                    <div class="type"> {{ item.type }}</div>
                    <div class="name">{{ item.remark }}</div>
                    <div class="time">{{ item.created_at }}</div>
                    <div v-if="item.type === '游戏道具' && !item.cdk" class="auto-send"></div>
                    <div v-else-if="item.type === '实体奖励'" class="btn-fill-address" @click="openAddressShow();"></div>
                    <div v-else class="btn-record-copy" @click="onCopy('.btn-record-copy', '复制成功，请前往游戏内兑换')" :data-clipboard-text="item.cdk"></div>
                  </div>
                </div>
              </div>
              <div class="bottom-tip"></div>
              <div class="btn-top-close" @click="drawRecordShow = false"></div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="drawRecordShow = false"></div>
        </div>
        <!-- 故事-领奖中心记录 -->
        <div class="story-record-wrap popup_wrap1" v-show="storyRecordShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="story-record-box popup_wrap-box" v-show="storyRecordShow">
              <div class="no-record" v-if="!user_activity.record || !user_activity.record.story_record.length"></div>
              <div v-else class="content-box">
                <div class="content">
                  <div v-for="(item, index) in (user_activity.record && user_activity.record.story_record || [])" :key="index" :class="`record-item status${item.status}`">
                    <div class="type"> {{ item.type }}</div>
                    <div class="name">{{ item.remark }}</div>
                    <div class="time">{{ item.created_at }}</div>
                    <div class="btn-story-record-copy" @click="onCopy('.btn-story-record-copy', '复制成功，请前往游戏内兑换')" :data-clipboard-text="item.cdk"></div>
                  </div>
                </div>
              </div>
              <div class="bottom-tip"></div>
              <div class="btn-top-close" @click="storyRecordShow = false"></div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="storyRecordShow = false"></div>
        </div>
        <!-- 设置弹窗 -->
        <div class="config-wrap popup_wrap1" v-show="configShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="config-box popup_wrap-box" v-show="configShow">
              <div class="content-box">
                <div class="account">镇长: {{ user_userInfo.account }}</div>
                <div class="btn-login" @click="handleChangeAccount"></div>
                <div class="btn-music" :class="isShowMusicBtn ? 'play' : 'stop'" @click="musicClick(isShowMusicBtn)"></div>
                <div class="btn-download" @click="onHandleDownload"></div>
              </div>
              <div class="btn-top-close" @click="configShow = false"></div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="configShow = false"></div>
        </div>
        <!-- 分享弹窗 -->
        <div class="share-wrap popup_wrap1" v-show="shareShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="share-box popup_wrap-box" v-show="shareShow">
              <img src="https://download4.qcplay.com/h5-images/active/ares/anniversary/bg_share.png" />
              <div class="btn-close-right" @click="shareShow = false"></div>
              <div class="btn-copy" @click="onCopy('.btn-copy');logger.sum('周年庆_复制分享链接');" data-clipboard-text="在？这次周年没你真不行，速来搭建周年庆场地，1年月卡、1周年神秘礼、游园币等豪礼已备好，就等你了！https://h5.qingcigame.com/ares/anniversary/enter"></div>
              <div class="btn-tip"></div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="shareShow = false"></div>
        </div>
        <!-- 求助弹窗 -->
        <div class="ask-help-wrap popup_wrap1" v-show="showHelp">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="ask-help-box popup_wrap-box" v-show="showHelp">
              <img :src="shareImg" />
              <div class="btn-close-right" @click="showHelp = false"></div>
              <div class="btn-copy-help" @click="onCopy('.btn-copy-help');logger.sum('周年庆_复制邀请链接')" :data-clipboard-text="`尼克镇长，这里是姜娜来电~\n周年庆的爱心餐，可以来帮我搭把手嘛！(◍•ᴗ•◍)❤\n备餐并参与活动，就有机会获得：\n⭐1年月卡福利！\n⭐神秘1周年礼物！\n⭐超多游园币！\n助力入口已出现→https://h5.qingcigame.com/ares/anniversary/enter?invite_code=${user_activity.invite_code}`"></div>
              <div class="btn-tip"></div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="showHelp = false"></div>
        </div>
        <!-- 待办清单 -->
        <div class="undo-wrap popup_wrap1" v-show="undoShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="undo-box popup_wrap-box" v-show="undoShow">
              <div class="content-box">
                <div v-for="(item, index) in user_activity.task_list || [{id: 1}]" :key="index" :class="`task-item status${item.status}`">
                  <div class="name"> {{ item.name }}</div>
                  <div class="reward-detail">
                    完成奖励: <span class="img-draw"></span> 抽奖券x{{ item.draw_num }} <span class="img-mucai"></span>木材 x {{ item.gold_coin }}
                  </div>
                  <div class="btn-reward" @click="onHandleTaskClick(item)" />
                </div>
              </div>
              <div class="top-material-box">
                <div class="material-box">
                  <div class="img-muchai"></div>
                  <div class="muchai-num">{{ user_activity.gold_coin }}</div>
                </div>
                <div class="draw-box">
                  <div class="img-choujiangquan"></div>
                  <div class="draw-num">{{ user_activity.draw_number }}</div>
                </div>
                <div class="detail-box" @click="detailShow = true;playClickMusic();logger.sum('周年庆_待办活动说明');"></div>
              </div>
              <div class="img-record-box"></div>
              <div class="btn-close" @click="undoShow = false"></div>
            </div>
          </transition>
        </div>
        <!-- 故事列表弹窗 -->
        <div class="story-wrap popup_wrap1" v-show="storyShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="story-box popup_wrap-box" v-show="storyShow">
              <div class="content-box">
                <div v-for="(item, index) in user_activity.story_progress" :key="index" :class="`story-item story-item-${item.id} status${item.status}`">
                  <div class="tip" v-if="item.id !== 6">{{ formatText(item) }}</div>
                  <div class="all-tip" v-else>
                    <div>完成前置{{item.current_level || 0}}/5剧情章节</div>
                    <div class="all-small-tip"></div>
                  </div>
                  <div class="btn-look" v-if="item.id === 6 && item.status === 2" :class="showRedTip ? 'red-tip' : ''" @click="handleRedTipClick">
                  </div>
                  <div class="btn-review" @click="onStoryClick(item)"></div>
                </div>
              </div>
              <div class="right-box">
                <div class="btn-draw-record" @click="storyRecordShow = true;playClickMusic();logger.sum('周年庆_故事领奖中心')"></div>
                <div class="btn-detail" @click="detailShow = true;playClickMusic()"></div>
              </div>
              <div class="btn-close" @click="storyShow = false"></div>
            </div>
          </transition>
        </div>
        <!-- 故事奖励弹窗 -->
        <div class="story-reward-wrap popup_wrap1" v-show="storyRewardShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="story-reward-box popup_wrap-box" v-show="storyRewardShow">
              <div class="content" :class="`reward${storyId}`">
              </div>
              <div class="btn-result-close" @click="handleCloseStoryReward"></div>
            </div>
          </transition>
        </div>
        <!-- 彩蛋合照弹窗 -->
        <div class="photo-wrap popup_wrap1" v-show="photoShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="photo-box popup_wrap-box" v-show="photoShow">
              <div class="btn-top-close" @click="photoShow = false"></div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="photoShow = false"></div>
        </div>
        <!-- buff弹窗 -->
        <div class="buff-wrap popup_wrap1" v-show="buffShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="buff-box popup_wrap-box" v-show="buffShow">
              <div class="btn-close" @click="buffShow = false"></div>
              <div class="top-material-box">
                <div class="material-box">
                  <div class="img-muchai"></div>
                  <div class="muchai-num">{{ user_activity.gold_coin }}</div>
                </div>
                <div class="draw-box">
                  <div class="img-choujiangquan"></div>
                  <div class="draw-num">{{ user_activity.draw_number }}</div>
                </div>
                <div class="detail-box" @click="detailShow = true;logger.sum('周年庆_暴击说明')"></div>
              </div>
              <div class="role-box"></div>
              <div class="buff-content-box">
                <div class="buff1-box" :class="`buff1-${user_activity.help_number}`">
                  <div :class="`buff-${user_activity.help_number}`" @click="onHandleAskHelpClick(1)"></div>
                </div>
                <div class="buff2-box" :class="`buff2-${user_activity.help_number}`">
                  <div :class="`buff-${user_activity.help_number}`" @click="onHandleAskHelpClick(2)"></div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <!-- 离线收益 -->
        <div class="go-back-wrap popup_wrap1" v-show="gobackShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="go-back-box popup_wrap-box" v-show="gobackShow">
              <div class="detail-content-box">
                <div class="before-buff">
                  <div class="left"></div>
                  <div class="num">{{ user_activity.income || 0 }}</div>
                </div>
                <div class="has-buff">
                  <div class="left"></div>
                  <div class="num">{{ user_activity.crit_rate === 0 ? '未激活' : `+${user_activity.crit_rate}%` }}</div>
                </div>
                <div class="after-buff">
                  <div class="total-income">{{ user_activity.crit_income || 0 }}</div>
                </div>
              </div>
              <div class="btn-play" @click="handlePlayClick"></div>
              <div class="btn-top-close" @click="gobackShow = false"></div>
            </div>
          </transition>
        </div>
        <!-- 首次获得buff弹窗 -->
        <div class="get-buff-wrap popup_wrap1" v-show="showBuff">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="get-buff-box popup_wrap-box" :class="`buff${buffType}`" v-show="showBuff">
              <div class="btn-top-close" @click="showBuff = false;logger.sum(`周年庆_获得暴击卡${buffType}`)"></div>
            </div>
          </transition>
        </div>
        <!-- 协助弹窗 -->
        <div class="help-wrap popup_wrap1" v-show="helpShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="help-box popup_wrap-box" v-show="helpShow">
              <div class="btn-help" @click="onHandleHelpClick"></div>
              <div class="btn-top-close" @click="helpShow = false"></div>
            </div>
          </transition>
        </div>
        <!-- 无需协助弹窗 -->
        <div class="no-need-help-wrap popup_wrap1" v-show="showNoNeedHelp">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="no-need-help-box popup_wrap-box" v-show="showNoNeedHelp">
              <div class="btn-play" @click="handleNoNeedClose();playClickMusic()"></div>
              <div class="btn-top-close" @click="handleNoNeedClose"></div>
            </div>
          </transition>
        </div>
        <!-- 协助失败(已经帮助过)弹窗 -->
        <div class="help-fail-wrap popup_wrap1" v-show="showHelpFail">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="help-fail-box popup_wrap-box" v-show="showHelpFail">
              <div class="btn-play" @click="handleHelpFailClose();playClickMusic()"></div>
              <div class="btn-top-close" @click="handleHelpFailClose"></div>
            </div>
          </transition>
        </div>
        <!-- 帮助自己失败弹窗 -->
        <div class="help-me-fail-wrap popup_wrap1" v-show="showHelpMe">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="help-me-fail-box popup_wrap-box" v-show="showHelpMe">
              <div class="btn-play" @click="handleHelpMeColse();playClickMusic()"></div>
              <div class="btn-top-close" @click="handleHelpMeColse"></div>
            </div>
          </transition>
        </div>
        <!-- 提示弹窗 -->
        <div :class="'tips-wrap tips-wrap-' + tipsShow">
          <div :class="'show-' + tipsShow2">
            <p>{{ tips }}</p>
          </div>
        </div>
        <!-- 抽奖奖励详情弹窗 -->
        <div class="draw-reward-detail-wrap popup_wrap1" v-show="drawRewardDetailShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="draw-reward-detail-box popup_wrap-box" v-show="drawRewardDetailShow">
              <div class="content" :class="`result${rewardDetail}`"></div>
              <div class="btn-top-close" @click="drawRewardDetailShow = false"></div>
            </div>
          </transition>
          <div class="close-bg" @click.stop="drawRewardDetailShow = false"></div>
        </div>
        <!-- NPC二次确认弹窗 -->
        <div class="npc-confirm-wrap popup_wrap1" v-show="npcConfirmShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="npc-confirm-box popup_wrap-box" v-show="npcConfirmShow">
              <div class="avatar" :class="`avatar${npcId}`"></div>
              <div class="title">
                确定要重温与<span>【{{ npcName[npcId]}}】</span>的对话吗？
              </div>
              <div class="btns">
                <div class="btn-confirm" @click="handleNpcConfirm"></div>
                <div class="btn-cancel" @click="npcConfirmShow = false;playClickMusic();"></div>
              </div>
            </div>
          </transition>
        </div>
        <!-- 助力无角色下载弹窗 -->
        <div class="no-role-wrap popup_wrap1" v-show="noRoleShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="no-role-box popup_wrap-box" v-show="noRoleShow">
              <div class="btn-go" @click="onHandleDownload"></div>
            </div>
          </transition>
        </div>
        <!-- 普通无角色下载弹窗 -->
        <div class="common-no-role-wrap popup_wrap1" v-show="commonNoRoleShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
            <div class="common-no-role-box popup_wrap-box" v-show="commonNoRoleShow">
              <div class="btn-go" @click="onHandleDownload"></div>
            </div>
          </transition>
        </div>
        <UnlockDialogueModal :dialogues="unlockDialogue" :visible="showUnlockDialogue" @close="handleDialogClose" />
        <StoryDialogueModal :dialogues="storyDialogue" :hasEnteredBefore="hasEnteredBefore" :introText="introText" :visible="showStoryDialogue" @close="handleStoryDialogClose" />
        <CakeModal :hasEnteredBefore="hasEnteredBefore" :visible="showCakeModal" @end="handleCakeModalClose" />
      </div>
      <!-- 登录弹窗 -->
      <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :noRoleName="true" game_id="41" :loginTypes="loginTypes" :downloadUrl="downloadUrl" channelTips="" noAuthLogin></Login>
      <Os v-if="isShowOs" @noRole="noRole" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"></Os>
      <!-- 地址信息弹窗 -->
      <div class="address-wrap popup_wrap1" v-show="addressShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div class="address-box popup_wrap-box" v-show="addressShow">
            <div class="content-box">
              <div class="name_class item">
                <span class="lebel">收件人</span>
                <label>
                  <input type="text" v-model.trim="name" maxlength="20" />
                </label>
              </div>
              <div class="phone_class item">
                <span class="lebel">手机号码</span>
                <label>
                  <input type="text" v-model.trim="phone" maxlength="11" />
                </label>
              </div>
              <div class="city_class item">
                <span class="lebel">所在地区</span>
                <label>
                  <input type="text" @click="showArea = true" v-model.trim="selected" disabled />
                </label>
                <Address @confirm="onCityConfirm" style="margin-left: auto;" />
              </div>
              <div class="address_class item">
                <span class="lebel">详细地址</span>
                <label>
                  <textarea type="text" v-model.trim="address" />
                  </label>
              </div>
              <div class="delivery_class item">
                <span class="lebel">快递单号</span>
                <label>
                  <input disabled type="text" v-model="user_activity.order_id" />
                </label>
                <div @click="onAddressCopy('.clipboard-class')" :data-clipboard-text="user_activity.order_id" class="clipboard-class">复制</div>
              </div>
              <div class="affirm-tip-box">
                <div class="affirm-tip"></div>
              </div>
              <div class="affirm-box">
                <div v-if="!user_activity.order_id && !user_activity.address_end" class="affirm" @click="handleConfirmAddress"></div>
              </div>
            </div>
            </div>
          </transition>
        <div class="close-bg" @click.stop="addressShow = false"></div>
      </div>

      <!-- 分享相关DOM -->
      <div class="share-box" ref="imageDom">
        <img
          src="https://download4.qcplay.com/h5-images/active/ares/anniversary/bg_ask_help.png"
        />
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
      </div>

      <!-- 地址提示弹窗 -->
        <div :class="'address-tips-wrap address-tips-wrap-' + addressTipsShow">
          <div :class="'address-show-' + addressTipsShow2">
            <p>{{ addressTips }}</p>
          </div>
        </div>
      <!-- 微信下载 -->
      <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active" :duration="{ enter: 1000 }">
          <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
        </transition>
        <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
// import Phaser from "Phaser";
import { Indicator, Toast } from "mint-ui";
import { debounce } from 'lodash'

import Os from "@/components/os";
import Login from "@/components/login";
import Address from "../components/address.vue";
import IntroOverlay from '../components/introOverlay.vue';
import UnlockDialogueModal from '../components/UnlockDialogueModal.vue';
import StoryDialogueModal from '../components/StoryDialogueModal.vue';
import CakeModal from '../components/CakeModal.vue';
import { mapState, mapMutations, mapActions } from "vuex";
import { onGetInitDataAPI, onLogoutAPI, draw, finishTask, getTaskReward, income, buildingUp, drawBigInfo, invite, getCumulative, getStory, submitAddress, downloadApps } from "../api";
import { getTimeStamp, buriedLogger, wechatBrowser, analysisParams } from "@/utils/utils";
import { generateQRCode, generateCanvasImage } from "@/utils/share";

import "../../../../assets/js/howler";

export default {
  components: {
    Login,
    Os,
    Address,
    IntroOverlay,
    UnlockDialogueModal,
    StoryDialogueModal,
    CakeModal,
  },
  data() {
    return {
      gameName: "ares",
      downloadUrl: 'https://ares.qingcigame.com',
      logger: null,
      // 其他数据
      loginTypes: ["sms", "password", "channel"],
      user_activity: {},
      user_userInfo: {},
      logoutShow: false,
      // 分享弹窗
      shareShow: false,
      shareImg: "",
      shareLink: "",
      isShow: false,
      // 音乐文件地址
      mp3url: "",
      // 是否显示音乐按钮
      isShowMusicBtn: true,
      // howler自动播放音乐
      bgMusic: {},
      peaceBgMusic: {},
      happyBgMusic: {},
      buildMusic: {},
      clickMusic: {},
      getMusic: {},
      cameraMusic: {},
      // 长按事件定时器
      timer: null,
      // 是否已分享
      isShare: false,


      enterLoading: true,
      progress: 0,
      game: null,
      score: 0,
      scoreText: '',
      drawShow: false,
      detailShow: false,
      shareShow: false,
      configShow: false,
      addressShow: false,
      undoShow: false,
      angle: 0,          // 当前角度
      spinning: false,    // 是否在旋转中
      name: '',
      phone: '',
      province: '',
      city: '',
      country: '',
      address: '',
      selected: '',
      showArea: false,
      gobackShow: false,
      helpShow: false,
      showIntro: false,
      loginMiddleShow: false,
      drawRecordShow: false,
      storyRecordShow: false,
      hasFontSizeInited: false,
      storyShow: false,
      // 提示语
      tips: "",
      // 提示显示1
      tipsShow: false,
      // 提示显示2
      tipsShow2: false,
      // 地址提示语
      addressTips: "",
      // 地址提示显示1
      addressTipsShow: false,
      // 地址提示显示2
      addressTipsShow2: false,
      resizeTimer: null,
      resizePending: false,
      realPageClick: { clientX: 0, clientY: 0 },
      buffShow: false,
      notice: [],
      currentNoticeIndex: 0,
      keySeed: 0,
      intervalTimer: null,
      cumulative_draw: 0, // 抽奖次数
      cumulative_progress: [
        {
          "id": 4,
          "name": "档位4",
          level_limit: 13,
          status: 0,
        },
        {
          "id": 3,
          "name": "档位3",
          level_limit: 11,
          status: 0,
        },
        {
          "id": 2,
          "name": "档位2",
          level_limit: 7,
          status: 0,
        },
        {
          "id": 1,
          "name": "档位1",
          level_limit: 3,
          status: 0,
        }
      ],
      wxLoadShow: false,
      showHelpFail: false,
      showNoNeedHelp: false,
      isInited: false,
      incomeTimer: null,
      income1: 0,
      income2: 0,
      income3: 0,
      income4: 0,
      income5: 0,
      formatIncome1: 0,
      formatIncome2: 0,
      formatIncome3: 0,
      formatIncome4: 0,
      formatIncome5: 0,
      showHelp: false,
      drawResultShow: false,
      drawResultId: 0,
      isPC: false,
      showUnlockDialogue: false,
    allUnlockDialogues: {
  1: [
    {
      name: '老镇长',
      className: 'dialog-laozhenzhang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_laozhenzhang.png',
      text: '还记得我小时候，那会儿还病毒没爆发，时常会有乐队前来表演，那是我听过最动人的旋律。可惜病毒爆发后，就再也没听到过了。',
      position: 'left',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '乐队…舞台！正好中心城区还有尚未完全废弃的舞台设备，或许我们可以利用起来。',
      position: 'right',
    },
    {
      name: '银狐',
      className: 'dialog-yinhu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_yinhu.png',
      text: '那儿我熟，交给我吧！',
      position: 'left',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '你不会搞什么鬼吧？',
      position: 'right',
    },
    {
      name: '银狐',
      className: 'dialog-yinhu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_yinhu.png',
      text: '我都被您收编了，哪敢啊，记得涨薪就行。',
      position: 'left',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '行行行，舞台搭建好了，亏不了你！',
      position: 'right',
    }
  ],
  2: [
    {
      name: '老军人',
      className: 'dialog-laojunren',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_laojunren.png',
      text: '我这一把老骨头了，还是得有个歇脚的地方，看看你们玩就行了。',
      position: 'left',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '嗯…来宾得有休息的地方，不如搭个露营区吧，虎哥你来帮忙搭建可否？',
      position: 'right',
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '得嘞，交给我，您放心。',
      position: 'left',
    },
  ],
  3: [
    {
      name: '铁牛',
      className: 'dialog-tieniu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_tieniu.png',
      text: '自从镇长带领希望镇重建之后，我这庄稼和牲畜长得也愈发好了，这次庆典所需的农作物我来供应！',
      position: 'left',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '妙哉！素菜是解决了，荤菜可咋办呢？',
      position: 'right',
    },
    {
      name: '老吴',
      className: 'dialog-laowu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_laowu.png',
      text: '荤菜交给我吧，别小瞧我老吴打猎的本领！上次多亏了镇长我才能和家人团聚，还有什么需要帮助的尽管和我说！',
      position: 'left',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '那就有劳铁牛和老吴了！',
      position: 'right',
    },
  ],
  4: [
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '这里有些空旷…',
      position: 'left',
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '怎么说？',
      position: 'right',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '摆点能“看”的东西，怎么样？',
      position: 'left',
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '设置个武器展示区？让大家直观感受到“安全感”？',
      position: 'right',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '平时沉默寡言的，但是关键时刻还是你有办法。',
      position: 'left',
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '那去邀请下马叔？他不是什么武器都能改造吗？',
      position: 'right',
    },
    {
      name: '马叔',
      className: 'dialog-mashu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_mashu.png',
      text: '小问题吗这不是~',
      position: 'left',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '说曹操曹操到！',
      position: 'right',
    },
    {
      name: '马叔',
      className: 'dialog-mashu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_mashu.png',
      text: '看这块挺热闹，来看看能不能帮上什么忙。这种事交给我就行了',
      position: 'left',
    },
  ],
  5: [
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '嗯…怎么让庆典更热闹呢？',
      position: 'left',
    },
    {
      name: '大壮',
      className: 'dialog-dazhuang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_dazhuang.png',
      text: '我闻到了商机',
      position: 'right',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '？！',
      position: 'left',
    },
    {
      name: '大壮',
      className: 'dialog-dazhuang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_dazhuang.png',
      text: '！？',
      position: 'right',
    },
    {
      name: '大壮',
      className: 'dialog-dazhuang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_dazhuang.png',
      text: '怎么？我来的不是时候吗？',
      position: 'right',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '不，你来的正是时候。',
      position: 'left',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '我打算在这开个小摊位，派发一些纪念品啥的，刚好你做生意，对库存补货这些还是比较擅长的...',
      position: 'left',
    },
    {
      name: '大壮',
      className: 'dialog-dazhuang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_dazhuang.png',
      text: '嗯....',
      position: 'right',
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '怎么？你不乐意？',
      position: 'left',
    },
    {
      name: '大壮',
      className: 'dialog-dazhuang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_dazhuang.png',
      text: '不，我在想怎么布置这个摊位会好点',
      position: 'right',
    },
    {
      name: '大壮',
      className: 'dialog-dazhuang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_dazhuang.png',
      text: '没事，交给我吧，我一定给整的漂漂亮亮的！',
      position: 'right',
    },
  ]
},
      unlockDialogue: [],
      building_id: null,
      currentBuilding: {},
      showUnlockModal: false,
      showLevelUpModal: false,
  allStoryDialogues: {
  1: [
    {
      name: '银狐',
      className: 'dialog-yinhu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_yinhu.png',
      text: '大功告成！尼克镇长瞧瞧！',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '想不到你还有这等本领！这效果…超出我的预期了。',
      position: 'right'
    },
    {
      name: '银狐',
      className: 'dialog-yinhu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_yinhu.png',
      text: '嘿嘿，小意思啦~镇长您看我这薪水，是不是也...得跟着“超出预期”一下？',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '你也知道，这年头，世道太乱了，咱手头也紧…',
      position: 'right'
    },
    {
      name: '银狐',
      className: 'dialog-yinhu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_yinhu.png',
      text: '姓尼的果然都不是好东西！',
      position: 'left'
    }
  ],
  2: [
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '尼克，都好了。遮阳避雨，地方宽敞，够大家伙儿歇脚！',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '关键时刻还得靠你，虎哥！虽然你免费，但效率真没话说！',
      position: 'right'
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '应该的。您忙着，我去看看...呃...似乎还差几个气球。',
      position: 'left'
    }
  ],
  3: [
    {
      name: '铁牛',
      className: 'dialog-tieniu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_tieniu.png',
      text: '镇长，看！咱镇子这粮食储备量！今年收成特别好，都是您重建镇子的功劳！',
      position: 'left'
    },
    {
      name: '老吴',
      className: 'dialog-laowu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_laowu.png',
      text: '正好，您来尝尝！刚烤好的羊腿，香着呢！',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '香！太丰盛了！辛苦二位！有你们在，大家伙的胃就有保障了！',
      position: 'left'
    },
    {
      name: '老吴',
      className: 'dialog-laowu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_laowu.png',
      text: '镇长，待会儿庆典开始，您可得留点肚子，后面...嘿嘿... (被铁牛用胳膊肘捅了一下)',
      position: 'right'
    }
  ],
  4: [
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '！！！！！！',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '交给马叔您来，我真是太放心了',
      position: 'left'
    },
    {
      name: '马叔',
      className: 'dialog-mashu',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_mashu.png',
      text: '怎么样镇长？',
      position: 'right'
    },
    {
      name: '铁锤',
      className: 'dialog-tiechui',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_tiechui.png',
      text: '尼克...假如让我拥有一把的话…',
      position: 'left'
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '那个，我也…',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '要的话自己赚积分去！',
      position: 'left'
    }
  ],
  5: [
    {
      name: '大壮',
      className: 'dialog-dazhuang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_dazhuang.png',
      text: '瞧一瞧看一看了啊！镇长，您看我这餐车布置的还行吧？',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '不错，很有节日气氛！',
      position: 'right'
    },
    {
      name: '大壮',
      className: 'dialog-dazhuang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_dazhuang.png',
      text: '嘿嘿，做生意嘛，门面很重要！不过您放心，庆典期间所有收入都归镇子建设！',
      position: 'left'
    },
    {
      name: '赫莉',
      className: 'dialog-heli',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_heli.png',
      text: '这个…这个…还有这个！给我来一打！',
      position: 'right'
    },
    {
      name: '大壮',
      className: 'dialog-dazhuang',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_dazhuang.png',
      text: '得嘞，富婆…哦不客官您慢走！',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '买这么多？看来当初房租还是收便宜了…',
      position: 'right'
    }
  ]
},
allNpcDialogues: {
  1: [
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '居然在这里见到你，稀客啊！',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '你个大男人咋还打个伞呢？',
      position: 'left'
    },
    {
      name: '汉特',
      className: 'dialog-hante',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_hante.png',
      text: '嘿嘿，小意思啦~你竟然忘了！我不能晒太阳，不然会满脸痘痘的！',
      position: 'right'
    },
    {
      name: '汉特',
      className: 'dialog-hante',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_hante.png',
      text: '我这次专程来找你的，是有一个任务要交给你…',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '等等等一下！不会又是兵封王座！',
      position: 'left'
    },
    {
      name: '汉特',
      className: 'dialog-hante',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_hante.png',
      text: '不不不…不是，是希望你能够把这届庆典好好完成！好让我也沾沾福利啊',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '那就好那就好~包在我身上！',
      position: 'left'
    }
  ],
  2: [
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '其实我感觉你近战不如铁锤。',
      position: 'left'
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '我免费啊老板。',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '远程输出不如田营生。',
      position: 'left'
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '我免费啊老板。',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '也没有任何精通加成。',
      position: 'left'
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '我免费啊老板。',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '行吧…那你情有可原，退下吧。',
      position: 'left'
    },
    {
      name: '虎哥',
      className: 'dialog-huge',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_huge.png',
      text: '老板666碗药汁麻烦结一下。',
      position: 'right'
    }
  ],
  3: [
    {
      name: '姜娜',
      className: 'dialog-jiangna',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_jiangna.png',
      text: '蛋糕上加点龙眼好了…',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '龙炎？什么龙炎！',
      position: 'right'
    },
    {
      name: '姜娜',
      className: 'dialog-jiangna',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_jiangna.png',
      text: '啊…不…没什么（慌张）',
      position: 'left'
    },
    {
      name: '姜娜',
      className: 'dialog-jiangna',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_jiangna.png',
      text: '尼克，你怎么来啦，场景搭的如何了~',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '托大伙儿的福，进展的很顺利~',
      position: 'right'
    },
    {
      name: '姜娜',
      className: 'dialog-jiangna',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_jiangna.png',
      text: '那就好，尼大镇长，辛苦你啦！~',
      position: 'left'
    },
    {
      name: '姜娜',
      className: 'dialog-jiangna',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_jiangna.png',
      text: '晚上我给大伙儿们加加餐~~',
      position: 'left'
    }
  ],
  4: [
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '别来无恙啊尼奥哥，最近身体如何~',
      position: 'left'
    },
    {
      name: '尼奥',
      className: 'dialog-niao',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_niao.png',
      text: '在港口拿我挡伤害的时候怎么不问我身体如何？',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '……',
      position: 'left'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '尼奥哥你听我狡辩！！',
      position: 'left'
    },
    {
      name: '尼奥',
      className: 'dialog-niao',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_niao.png',
      text: '不用了尼大镇长，平时记得好好锻炼身体，希望镇没了你可不行。',
      position: 'right'
    },
    {
      name: '琳',
      className: 'dialog-lin',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_lin.png',
      text: '尼奥！来吃水果啦！',
      position: 'left'
    },
    {
      name: '尼奥',
      className: 'dialog-niao',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_niao.png',
      text: '来了dar琳！',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '小声）想不到严肃的尼奥大哥也有这一面…',
      position: 'left'
    }
  ],
  5: [
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '锤哥，365天无休上班，辛苦你了！',
      position: 'left'
    },
    {
      name: '铁锤',
      className: 'dialog-tiechui',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_tiechui.png',
      text: '……',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '庆典场景搭建完给你放年假！',
      position: 'left'
    },
    {
      name: '铁锤',
      className: 'dialog-tiechui',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_tiechui.png',
      text: '……',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '带薪的！',
      position: 'left'
    },
    {
      name: '铁锤',
      className: 'dialog-tiechui',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_tiechui.png',
      text: '……',
      position: 'right'
    },
    {
      name: '尼克',
      className: 'dialog-nike',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_nike.png',
      text: '我会去看你打拳赛的！',
      position: 'left'
    },
    {
      name: '铁锤',
      className: 'dialog-tiechui',
      avatar: 'https://download4.qcplay.com/h5-images/active/ares/anniversary/img_tiechui.png',
      text: '好的！',
      position: 'right'
    }
  ]
},
      storyDialogue: [],
      showStoryDialogue: false,
      introText: '',
      areaName: ['', '庆典舞台', '露天营地', '野炊小栈', '武器展台', '纪念摊位'],
      helpName: ['', '银狐', '虎哥', '老吴', '马叔', '大壮'],
      hasEnteredBefore: false,
      storyId: 0,
      storyRewardShow: false,
      showBuff: false,
      buffType: 1,
      npcConfirmShow: false,
      npcName: ['', '汉特', '虎哥', '姜娜', '尼奥', '铁锤'],
      npcId: 0,
      drawRewardDetailShow: false,
      rewardDetail: 0,
      showRedTip: false,
      photoShow: false,
      showHelpMe: false,
      npcList: [],
      allNpcs: [
        { id: 1, class: 'hante', name: 'hante' },
        { id: 2, class: 'huge', name: 'huge' },
        { id: 3, class: 'jiangna', name: 'jiangna' },
        { id: 4, class: 'niao', name: 'niao' },
        { id: 5, class: 'tiechui', name: 'tiechui' }
      ],
      currentNpcId: null,
      isSpeaking: false,
      isCoolingDown: false,
      currentLine: '',
      npcLines: {
        hante: ['猜猜哪个族会是下个倒霉蛋呢？', '尼克，准备好迎接新任务吗？'],
        huge: ['口渴了，好想喝小药汁…', '今天又挣了0元，嘿嘿…'],
        jiangna: ['晚饭给大家做什么好呢？', '尼克他会喜欢这个吗…'],
        niao: ['别摸鱼了尼克！', '真希望K也在这…'],
        tiechui: ['好想回去打拳…', '想当年我还是拳王的时候…']
      },
      showCakeModal: false,
      collectting: false,
      downloadUrls: {
        android_url: 'https://download4.qcplay.com/apk-v2/qc-kol-1168343.apk',
        ios_url: 'https://apps.apple.com/cn/app/%E9%98%BF%E7%91%9E%E6%96%AF%E7%97%85%E6%AF%922/id6503130455',
      },
      currentBgmType: 'relaxed',
      noRoleShow: false,
      commonNoRoleShow: false,
    }
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 埋点
    const bl = buriedLogger("ares", "阿瑞斯2_周年庆");
    this.logger = bl;
    const params = analysisParams(window.location.href);
    const { download_id, title } = params;
    downloadApps({ download_id, title }).then((res) => {
      if (res.code === 200) {
        this.downloadUrls = res.data
      }
    })
  },
  mounted() {
    // 模拟加载进度
    const timer = setInterval(() => {
      if (this.progress < 100) {
        this.progress += 4;
        // this.progress += 10; // 加速版
      } else {
        clearInterval(timer);
        this.enterLoading = false
        // 判断是否已经播放过黑幕 intro，如果没有才展示
        if (!localStorage.getItem('introPlayed')) {
          this.showIntro = true;
        } else {
          // 已播放 intro，直接跳到首页（不展示黑幕）
          this.showIntro = false;
        }
        // 如果有助力展示助力弹窗
        const params = analysisParams(window.location.href);
        const { invite_code } = params;
        if (invite_code) {
          this.helpShow = true
        }
        this.getLoginContainer();
        this.showRedTip = localStorage.getItem('redTip') !== 'showed'
        // this.initBg()
      }
    }, 30);
    // 初始化
    this.$nextTick(() => {
      this.forceLandscapeScreenHandle();
      this.onWindowSizeChanged();
      this.startLoading();
      this.getDrawInfoList()
      this.isSetShare();
      try {
       this.peaceBgMusic = new Howl({
          preload: true,
          loop: true,
          volume: 0.2,
          src: [
            'https://download4.qcplay.com/h5-images/active/ares/anniversary/peaceBg.mp3'
          ]
        });

      this.happyBgMusic = new Howl({
        preload: true,
        loop: true,
        volume: 0,
        src: [
          'https://download4.qcplay.com/h5-images/active/ares/anniversary/happyBg.mp3'
        ]
      });

      this.clickMusic = new Howl({
        preload: true,
        src: [
          'https://download4.qcplay.com/h5-images/active/ares/anniversary/click.mp3'
        ]
      });

      this.buildMusic = new Howl({
        preload: true,
        src: [
          'https://download4.qcplay.com/h5-images/active/ares/anniversary/build.mp3'
        ]
      });

      this.cameraMusic = new Howl({
        preload: true,
        src: [
          'https://download4.qcplay.com/h5-images/active/ares/anniversary/camera.mp3'
        ]
      });

      this.getMusic = new Howl({
        preload: true,
        volume: 0.5,
        src: [
          'https://download4.qcplay.com/h5-images/active/ares/anniversary/get.mp3'
        ]
      });
        
        this.bgMusic = this.peaceBgMusic
        this.bgMusic.play()
        this.isShowMusicBtn = true
      } catch (err) { }
    });
    // document.addEventListener('mousedown', (e) => {
    //   this.realPageClick.clientX = e.clientX;
    //   this.realPageClick.clientY = e.clientY;
    // });

    // document.addEventListener('touchstart', (e) => {
    //   if (e.touches && e.touches[0]) {
    //     this.realPageClick.clientX = e.touches[0].clientX;
    //     this.realPageClick.clientY = e.touches[0].clientY;
    //   }
    // }, { passive: true });
  },
  beforeDestroy() {
    if (this.game) {
      this.game.destroy(true); // 正确销毁，会释放 canvas、事件
      this.game = null;
    }
    if (this.incomeTimer) {
      clearInterval(this.incomeTimer)
      this.incomeTimer = null
    }
    this.bgMusic = {}
    this.peaceBgMusic = {}
    this.happyBgMusic = {}
    clearInterval(this.intervalTimer);
    window.removeEventListener('resize', this.forceLandscapeScreenHandle);
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.shareImg = "";
        } else if (newValue.role_id !== oldValue.role_id) {
          // TAG: 初始登陆/切换角色的时候
        }
      },
    },
  },

  methods: {
    onIntroFinished() {
      // 动画结束，标记为已播放
      localStorage.setItem('introPlayed', 'true');
      this.showIntro = false;
    },
    // 创建背景动画
    initBg() {
      // 防止重复创建
      if (this.game) {
        this.game.destroy(true);
        this.game = null;
      }
      // 清除之前的容器内容，防止 canvas 累计
      const container = this.$refs.gameContainer;
      if (container) container.innerHTML = "";
      const vueContext = this

      this.game = new Phaser.Game({
        type: Phaser.AUTO,
        parent: this.$refs.gameContainer,
        width: window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight,
        height: window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth,
        // width: 1334,   // 设计分辨率横屏值
        // height: 750,
        physics: {
          default: 'arcade',
          arcade: {
            gravity: { y: 0 },
            debug: false
          }
        },
        scene: {
          preload() {
          const base = 'https://download4.qcplay.com/h5-images/active/ares/anniversary/';

          this.load.setBaseURL(base);

          this.load.image('bg', 'bg.png');
          this.load.image('storyBtn', 'btn_story.png');
          this.load.image('undoBtn', 'btn_todo.png');
          this.load.image('getBtn', 'btn_get.png');
          this.load.image('detailBtn', 'btn_detail.png');
          this.load.image('configBtn', 'btn_config.png');
          this.load.image('shareBtn', 'btn_share.png');
          this.load.image('drawBtn', 'modal_draw.png');
          this.load.image('avatar', 'img_avatar.png');
          this.load.image('weapon', 'weapon_box_lock.png');
          this.load.spritesheet('dude', 'dude.png', { frameWidth: 32, frameHeight: 48 });
          },
          create() {
            const { width, height } = this.sys.game.config;
            const bg = this.add.image(width / 2, height / 2, 'bg');
            // this.scale.on('resize', () => {
            //   this.scene.restart(); // 简单粗暴，重启场景以重新旋转内容
            // });
            bg.setOrigin(0.5, 0.5)
            // 计算按宽度铺满时对应的 scale
            const img = this.textures.get('bg').getSourceImage();
            const scaleX = width / img.width;
            const finalHeight = img.height * scaleX;
            console.log('scaleX', scaleX, width, height)
            bg.setScale(scaleX); // 只横向缩放，纵向跟着等比缩放
            bg.displayHeight = finalHeight;
            bg.y = finalHeight / 2;
            // bg.y = height / 2;
            // bg.setPosition(width / 2, height / 2)
            // 限制 camera 只能纵向拖动
            const dragExtra = Math.max(0, height - finalHeight);
            this.cameras.main.setBounds(0, -dragExtra / 2, width, finalHeight + dragExtra);
            const platforms = this.physics.add.staticGroup(); // 创建静态物理组

            const buildings = []
            function createBuilding(scene, config) {
              const { x, y, key, level = 1, onUpgrade, origin } = config;

              const building = scene.add.image(x, y, key)
                .setInteractive({ useHandCursor: true })
                .setScale(scaleX)
                .setOrigin(origin.x, origin.y)

              building.level = level;

              // 添加等级文本
              const text = scene.add.text(x, y + 40, `Lv.${level}`, {
                fontSize: '16px',
                fill: '#fff'
              }).setOrigin(0.5).setScrollFactor(0);

              // 点击可以弹出升级气泡等
              building.on('pointerdown', () => {
                onUpgrade(building);
              });

              // 可组合放入 container 中，或 manageBuildings 数组
              return {
                sprite: building,
                levelText: text,
                updateLevel(newLevel) {
                  text.setText(`Lv.${newLevel}`);
                  building.level = newLevel;
                },
                destroy() {
                  building.destroy();
                  text.destroy();
                }
              };
            }

            const b1 = createBuilding(this, {
              x: 140,
              y: 0,
              key: 'weapon',
              level: 5,
              origin: { x: 0, y: 0 },
              onUpgrade: (building) => {
                console.log(building);
              }
            });

            buildings.push(b1);

            // 左上角容器
            function createTopLeftUI(scene) {
              const container = scene.add.container(0, 0).setScrollFactor(0);

              const LINE_WIDTH = 110; // 按你的按钮背景宽度来设
              const LINE_X = 160; // 你的背景条左上角 x 坐标
              const avatar = scene.add.image(0, 0, 'avatar').setOrigin(0).setInteractive();
              const txtIncome = scene.add.text(0, 24, `${vueContext.user_activity.speed_produce || 0}/秒`, { fontSize: '20px', fill: '#fff' }).setOrigin(0.5, 0.5).setResolution(window.devicePixelRatio || 1);
              const txtMucai = scene.add.text(0, 62, vueContext.user_activity.gold_coin || 0, { fontSize: '20px', fill: '#fff' }).setOrigin(0.5, 0.5).setResolution(window.devicePixelRatio || 1);
              const txtDraw = scene.add.text(0, 100, vueContext.user_activity.draw_number || 0, { fontSize: '20px', fill: '#fff' }).setOrigin(0.5, 0.5).setResolution(window.devicePixelRatio || 1);
              txtIncome.x = LINE_X + LINE_WIDTH / 2;
              txtMucai.x = LINE_X + LINE_WIDTH / 2;
              txtDraw.x = LINE_X + LINE_WIDTH / 2;
              container.add([avatar, txtIncome, txtMucai, txtDraw]);
              container.setScale(scaleX)
              const safeTop = Math.max(0, scene.scale.height - finalHeight) / 2;
              container.setPosition(10, safeTop + 10); // 安全边距
              return {
                container,
                avatar,
                txtIncome,
                txtMucai,
                txtDraw
              };
            }

            const topLeftUI = createTopLeftUI(this);
            vueContext.topLeftUI = topLeftUI;

            // platforms.create(width / 2, height - 2.56 * 32 / 2, 'ground').setScale(2.56).refreshBody();

            // platforms.create(width - 400 / 2, 400, 'ground');
            // platforms.create(width / 2, 300, 'ground');
            // platforms.create(50, 250, 'ground');
            // platforms.create(width, 220, 'ground');

            // player.setBounce(0.2);  // 碰到物理组的反弹度
            // player.setCollideWorldBounds(true);
            const xRatio = scaleX * 2
            const yRatio = height / 375
            const designPath = [
              { x: 667 + 20, y: 189 }, // 起点-你角色的位置
              { x: 510, y: 189 }, // 向左
              { x: 430, y: 174 }, // 向左上
              { x: 320, y: 174 }, // 向左
              { x: 300, y: 182 }, // 向左下
              { x: 250, y: 170 }, // 向左下
              { x: 160, y: 120 }, // 继续向左上
              { x: 260, y: 180 }, // 向右
              { x: 240, y: 200 },
              { x: 220, y: 240 },
              { x: 220, y: 280 },
              { x: 240, y: 300 },
              { x: 280, y: 340 },
              { x: 280, y: 420 },
            ];
            const designPath2 = [
              { x: 667 + 20, y: 186 },
              { x: 510, y: 186 },
              { x: 430, y: 174 },
              { x: 360, y: 174 },
              { x: 360, y: 310 },
              { x: 300, y: 340 },
              { x: 280, y: 380 },
              { x: 270, y: 420 },
            ];
            const designPath3 = [
              { x: 667 + 20, y: 186 },
              { x: 510, y: 186 },
              { x: 430, y: 174 },
              { x: 360, y: 174 },
              { x: 320, y: 200 },
              { x: 290, y: 206 },
              { x: 270, y: 214 },
              { x: 260, y: 224 },
              { x: 250, y: 234 },
              { x: 250, y: 274 },
              { x: 200, y: 310 },
              { x: 170, y: 328 },
              { x: 100, y: 308 },
              { x: 170, y: 328 },
              { x: 200, y: 310 },
              { x: 270, y: 330 },
              { x: 286, y: 350 },
              { x: 270, y: 420 },
            ];
            const path = designPath.map(p => ({
              x: p.x * scaleX,
              y: p.y * scaleX
            }));
            const path2 = designPath2.map(p => ({
              x: p.x * scaleX,
              y: p.y * scaleX
            }));
            const path3 = designPath3.map(p => ({
              x: p.x * scaleX,
              y: p.y * scaleX
            }));
            // path3.forEach(p => {
            //   this.add.circle(p.x, p.y, 4, 0xff0000); // 用红点标记路径点
            // });
            const player = this.physics.add.sprite(width - 20, 189, 'dude'); // 创建NPC1
            player.setData('name', 'npc1');
            player.setScale(xRatio); // 保证和背景一致的缩放比例

            this.player = player
            const player2 = this.physics.add.sprite(width - 50, 189, 'dude');
            player2.setData('name', 'npc2');
            player2.setScale(xRatio)
            this.player2 = player2
            const player3 = this.physics.add.sprite(width - 100, 189, 'dude');
            player3.setData('name', 'npc3');
            player3.setScale(xRatio)
            this.player3 = player3
            this.moveAlongPath = (sprite, points, speed) => {
              let currentIndex = 0;

              const moveToNextPoint = () => {
                const from = points[currentIndex];
                const to = points[currentIndex + 1];
                const distance = Phaser.Math.Distance.Between(from.x, from.y, to.x, to.y);
                const duration = distance / speed * 1000;

                sprite.setPosition(from.x, from.y); // 精确起点

                const tween = this.tweens.add({
                  targets: sprite,
                  x: to.x,
                  y: to.y,
                  duration,
                  ease: 'Linear',

                  onStart: () => {
                    if (to.x > from.x) sprite.anims.play('right', true);
                    else if (to.x < from.x) sprite.anims.play('left', true);
                    else sprite.anims.play('turn');
                  },

                  onComplete: () => {
                    currentIndex++;

                    // 最后一段结束后：立刻销毁角色
                    if (currentIndex >= points.length - 1) {
                      // sprite.destroy(); // 彻底移除角色
                      // sprite.setVisible(false); // 如果你不想销毁
                      sprite.setPosition(points[0].x, points[0].y)
                      this.moveAlongPath(sprite, points, speed);
                    } else {
                      moveToNextPoint(); // 👉 继续移动到下一个点
                    }
                  }
                });
              };

              if (points.length >= 2) {
                moveToNextPoint(); //开始走路径
              }
            };
            // this.moveAlongPath(player, path, 40); // 速度可调整

            // 第二个角色
            this.time.delayedCall(2000, () => {
              // this.moveAlongPath(player2, path2, 40);
            }, null, this);
            this.time.delayedCall(4000, () => {
              // this.moveAlongPath(player3, path3, 40);
            }, null, this);

            // 创建气泡（文字+背景）
            this.activeBubbles = []; // 储存当前所有可见的气泡容器
            // 台词显示控制状态
            this.dialogueBusy = false;
            this.showTalkBubble = (sprite, message) => {
              if (this.dialogueBusy) return;

              this.dialogueBusy = true;
              const offsetY = -60;
              const padding = 10;

              // Create text and style
              const fontSize = 24 * xRatio; // 基准字体大小是 16px
              const text = this.add.text(padding, padding, message, {
                fontSize: `${fontSize}px`,
                fill: '#000',
                align: 'center',
                fontWeight: 'bold',
                wordWrap: { width: 160 * scaleX },
                resolution: window.devicePixelRatio // ⭐ 设置为当前设备像素比
              });

              const textW = text.width;
              const textH = text.height;

              // Create speech bubble background
              const bubble = this.add.graphics();
              bubble.fillStyle(0xffffff, 1);
              bubble.fillRoundedRect(0, 0, textW + padding * 2, textH + padding * 2, 8);

              // Add triangle arrow
              bubble.fillTriangle(
                textW / 2 + padding - 6, textH + padding * 2,
                textW / 2 + padding + 6, textH + padding * 2,
                textW / 2 + padding, textH + padding * 2 + 8
              );

              // Add to container
              // ⬇ 组合容器：容器的 x=角色x - 实际宽度/2，y=角色.y + offset
              const bubbleWidth = textW + padding * 2;
              const bubbleHeight = textH + padding * 2 + 10;
              const container = this.add.container(
                sprite.x - bubbleWidth / 2,
                sprite.y + offsetY,
                [bubble, text]
              );

              container.setScale(scaleX)

              // function bindSafeTap(gameObject, { onTap }) {
              //   let downX = 0;
              //   let downY = 0;
              //   let validTap = false;

              //   gameObject.on('pointerdown', (pointer) => {
              //     downX = pointer.worldX;
              //     downY = pointer.worldY;
              //     validTap = true;
              //   });

              //   gameObject.on('pointerup', (pointer) => {
              //     if (!validTap) return;

              //     const dx = Math.abs(pointer.worldX - downX);
              //     const dy = Math.abs(pointer.worldY - downY);

              //     const distanceThreshold = 10;

              //     if (dx < distanceThreshold && dy < distanceThreshold) {
              //       // ✅ 视作点击
              //       console.log('点击')
              //       onTap(pointer);
              //     }

              //     validTap = false;
              //   });

              //   gameObject.on('pointerout', () => {
              //     validTap = false;
              //   });
              // }

              // bindSafeTap(container, {
              //   onTap: () => {
              //     vueContext.handleBubbleClick(sprite); // ✅ 真点击才触发
              //   }
              // });

              // 绑定点击事件
              container.on('pointerdown', () => {
                vueContext.handleBubbleClick(sprite);
              });

              // container.setInteractive(
              //   new Phaser.Geom.Rectangle(0, 0, bubbleWidth, bubbleHeight),
              //   (shape, x, y, gameObject) => {
              //     return x > 20 && x < width - 20 && y > 20 && y < height - 20;
              //   }
              // );

              container.setInteractive(
                new Phaser.Geom.Rectangle(0, 0, bubbleWidth, bubbleHeight),
                Phaser.Geom.Rectangle.Contains
              );

              // ⬇⬇⬇ 添加点击功能必备：
              container.setSize(bubbleWidth, bubbleHeight); // 📏必须要设置宽高

              // 调试气泡框的
              const debugRect = this.add.graphics();
              debugRect.lineStyle(2, 0xff0000, 1);
              debugRect.strokeRect(0, 0, bubbleWidth, bubbleHeight);
              container.add(debugRect);

              // 防止子元素阻隔
              text.disableInteractive();
              bubble.disableInteractive();
              // this.children.bringToTop(container);

              // 注册动态更新跟随
              this.activeBubbles.push({ container, sprite, offsetY, width: bubbleWidth * scaleX });

              // 2 秒后销毁
              this.time.delayedCall(2000, () => {
                container.destroy();
                this.activeBubbles = this.activeBubbles.filter(c => c.container !== container);
                this.dialogueBusy = false;
              });
            };

            // 示范对话（你可以扩展为随机内容、对话列表等）
            const dialogue1 = ['你好呀！', '又见面了。'];
            const dialogue2 = ['天气不错', '我去前面看看'];
            const dialogue3 = ['好家伙', '真棒棒'];

            let index1 = 0;
            let index2 = 0;
            let index3 = 0;

            this.time.addEvent({
              delay: 7000,   // 每7s尝试调用一次
              loop: true,
              callback: () => {
                // 如果还在显示上一次台词，就跳过
                if (this.dialogueBusy) return;

                // 决定谁说话（可以交替逻辑/随机/AI判断）
                const pick = Phaser.Math.Between(0, 2); // 随机选择说话角色
                if (pick === 0 && this.player) {
                  this.showTalkBubble(this.player, dialogue1[index1 % dialogue1.length])
                  index1++
                } else if (pick === 1 && this.player2) {
                  this.showTalkBubble(this.player2, dialogue2[index2 % dialogue2.length])
                  index2++
                } else if (pick === 2 && this.player3) {
                  this.showTalkBubble(this.player3, dialogue3[index3 % dialogue3.length])
                  index3++
                }
              }
            });

            // 创建方向动画
            if (!this.anims.exists('left')) {
              this.anims.create({
                key: 'left',
                frames: this.anims.generateFrameNumbers('dude', { start: 0, end: 3 }),
                frameRate: 10,
                repeat: -1
              });
            }

            if (!this.anims.exists('turn')) {
              this.anims.create({
                key: 'turn',
                frames: [{ key: 'dude', frame: 4 }],
                frameRate: 20
              });
            }

            if (!this.anims.exists('right')) {
              this.anims.create({
                key: 'right',
                frames: this.anims.generateFrameNumbers('dude', { start: 5, end: 8 }),
                frameRate: 10,
                repeat: -1
              });
            }
            // 添加按钮

            function getCorrectedPointerXY(clientX, clientY, canvas) {
              const rect = canvas.getBoundingClientRect();

              const originX = rect.left + rect.width / 2;
              const originY = rect.top + rect.height / 2;

              // 相对于中心的偏移
              const dx = clientX - originX;
              const dy = clientY - originY;

              // 画布顺时针旋转了 90°（我们要逆转回去）
              const rad = -Math.PI / 2;
              const rx = dx * Math.cos(rad) - dy * Math.sin(rad);
              const ry = dx * Math.sin(rad) + dy * Math.cos(rad);

              // 回到屏幕坐标
              const finalX = rx + originX;
              const finalY = ry + originY;

              // 映射到游戏逻辑坐标
              const scaleX = canvas.width / rect.width;
              const scaleY = canvas.height / rect.height;

              const gameX = (finalX - rect.left) * scaleX;
              const gameY = (finalY - rect.top) * scaleY;

              return { x: gameX, y: gameY };
            }
            const clickableButtons = [];

            // 注册一个按钮（封装）
            function registerInteractiveButton(scene, imageKey, position, onClick, origin) {
              const btn = scene.add.image(position.x, position.y, imageKey);
              btn.setInteractive({
                useHandCursor: true,
              });
              btn.setScrollFactor(0);
              btn.name = imageKey;
              origin && btn.setOrigin(origin.x, origin.y);
              btn.setScale(scaleX);
              btn.setPosition(position.x, position.y)

              btn.onClick = onClick;
              clickableButtons.push(btn);

              return btn;
            }
            // 到时候得区分高度（是否在上帝视角能拖动）,一旦是很长的手机，就会出现按钮在游戏外
            const minHeight = Math.min(this.scale.height, height / 2 + finalHeight / 2)
            const safeTop = Math.max(0, this.scale.height - finalHeight) / 2;
            registerInteractiveButton(this, 'storyBtn', { x: 0, y: minHeight }, () => {
              vueContext.onHandlestoryClick()
            }, { x: 0, y: 1 });
            registerInteractiveButton(this, 'undoBtn', { x: width, y: minHeight }, () => {
              vueContext.onHandleUndoClick()
            }, { x: 1, y: 1 });
            registerInteractiveButton(this, 'getBtn', { x: width - 20, y: minHeight - 80 }, () => {
              console.log('一键收割');
            }, { x: 1, y: 0.5 });
            registerInteractiveButton(this, 'detailBtn', { x: width - 20, y: safeTop + 10 }, () => {
              vueContext.onHandleDetailClick()
            }, { x: 1, y: 0 });
            registerInteractiveButton(this, 'configBtn', { x: width - 120 * scaleX, y: safeTop + 10 }, () => {
              vueContext.onHandleConfigClick()
            }, { x: 1, y: 0 });
            registerInteractiveButton(this, 'shareBtn', { x: width - 200 * scaleX, y: safeTop + 10 }, () => {
              vueContext.onHandleShareClick()
            }, { x: 1, y: 0 });
            registerInteractiveButton(this, 'drawBtn', { x: width - 20, y: safeTop + 60 }, () => {
              vueContext.onHandleDrawClick()
            }, { x: 1, y: 0 });
            // 画布拖动
            // 拖动标记
            let isDragging = false;
            let startX = 0;
            let startY = 0;

            this.input.on('pointerdown', (pointer) => {
              isDragging = true;
              startX = pointer.x;
              startY = pointer.y;
            });

            this.input.on('pointerup', (pointer) => {
              isDragging = false;
              let x, y
              if (window.innerWidth > window.innerHeight) {
                const { x: pointerX, y: pointerY } = pointer
                x = pointerX
                y = pointerY
              } else {

                // const { x: pointerX, y: pointerY } = pointer
                // const { x: pointerX, y: pointerY } = getCorrectedPointerXY(pointer, this.sys.canvas)
                // const { x: pointerX, y: pointerY } = getCorrectedPointerXY(vueContext.realPageClick.clientX, vueContext.realPageClick.clientY, this.sys.canvas)
                // console.log("实际点击", vueContext.realPageClick.clientX, vueContext.realPageClick.clientY)
                // console.log("触发了：", pointerX, pointerY)
                // console.log("---：", pointer.y, pointer.x)
                x = vueContext.realPageClick.clientX
                y = vueContext.realPageClick.clientY
              }
              this.add.circle(x, y, 10, 0xff0000);

              for (const btn of clickableButtons) {
                const bounds = btn.getBounds();
                if (window.innerWidth > window.innerHeight) {
                  if (x >= bounds.x && x <= bounds.right && y >= bounds.y && y <= bounds.bottom) {
                    btn.onClick();
                    break;
                  }
                } else {
                  if ((y >= bounds.x) && (y <= bounds.right) && (x > (height - bounds.bottom)) && (x <= height - bounds.y)) {
                    btn.onClick();
                    break;
                  }
                }
              }
            });

            this.input.on('pointermove', (pointer) => {
              if (!isDragging) return;

              const dx = pointer.x - startX;
              const dy = pointer.y - startY;

              const isLandscape = window.innerWidth > window.innerHeight;

              if (isLandscape) {
                // 视觉上的 Y 滚动（上下拖动）实际上是 👇 pointer 横向移动
                this.cameras.main.scrollY -= dy; // 👈 用 dx 控制 camera.scrollY
              } else {
                // 竖屏：x 控制 Y
                this.cameras.main.scrollY += dx;
              }

              startX = pointer.x;
              startY = pointer.y;
            });
          },
          update() { // 变化函数
            // 更新所有活跃的气泡
            if (this.activeBubbles && this.activeBubbles.length) {
              this.activeBubbles.forEach(obj => {
                const { container, sprite, offsetY, width } = obj;
                container.setPosition(Math.round(sprite.x - width / 2), Math.round(sprite.y - sprite.displayHeight * 1.2));
              });
            }
          }
        },
        resolution: window.devicePixelRatio || 1,
        // parent: "gameContainer",
        scale: {
          // mode: Phaser.Scale.FIT,       // 缩放适配到容器
          // autoCenter: Phaser.Scale.CENTER_BOTH,
          resolution: window.devicePixelRatio || 1, // ✅ 核心
        }
      });
    },
    getSectorPath(index, total, outerR, innerR = 70) {
      const anglePer = 360 / total;
      const offset = -90;

      const startAngle = anglePer * index + offset;
      const endAngle = startAngle + anglePer;

      const toRad = deg => (deg * Math.PI) / 180;

      // 外圈点
      const x1 = 306 + outerR * Math.cos(toRad(startAngle));
      const y1 = 306 + outerR * Math.sin(toRad(startAngle));
      const x2 = 306 + outerR * Math.cos(toRad(endAngle));
      const y2 = 306 + outerR * Math.sin(toRad(endAngle));

      // 内圈点
      const x3 = 306 + innerR * Math.cos(toRad(endAngle));
      const y3 = 306 + innerR * Math.sin(toRad(endAngle));
      const x4 = 306 + innerR * Math.cos(toRad(startAngle));
      const y4 = 306 + innerR * Math.sin(toRad(startAngle));

      const largeArc = anglePer > 180 ? 1 : 0;

      return `
        M ${x1} ${y1}
        A ${outerR} ${outerR} 0 ${largeArc} 1 ${x2} ${y2}
        L ${x3} ${y3}
        A ${innerR} ${innerR} 0 ${largeArc} 0 ${x4} ${y4}
        Z
      `;
    },
    switchBgmTo(type) {
      if (this.currentBgmType === type) return;

      const fromBgm = this.bgMusic;
      const toBgm = (type === 'happy') ? this.happyBgMusic : this.peaceBgMusic;

      // 渐出旧音乐
      fromBgm.fade(fromBgm.volume(), 0, 1000);
      setTimeout(() => {
        fromBgm.stop();

        // 渐入新音乐
        toBgm.volume(0);
        toBgm.play();
        toBgm.fade(0, 0.2, 2000);

        this.bgMusic = toBgm;
        this.currentBgmType = type;
      }, 1000);
    },
    handleCloseStoryReward() {
      this.storyRewardShow = false;
      this.showStoryDialogue = false;
      this.playClickMusic();
      const name = this.areaName[this.storyId] || '彩蛋'
      this.logger.sum(`周年庆_${name}奖励领取`)
    },
    handlePlayClick() {
      this.playClickMusic()
      if (this.collectting) return
      this.collectting = true
      this.gobackShow = false;
      this.collectAllCoins()
    },
    flyCoin(startX, startY, endX, endY) {
      // 创建 coin DOM
      const coin = document.createElement('div');
      coin.className = 'coin';

      // 设置基本样式
      coin.style.position = 'absolute';
      coin.style.left = `${startX}px`;
      coin.style.top = `${startY}px`;
      coin.style.width = '40px';
      coin.style.height = '40px';
      coin.style.backgroundImage = `url("https://download4.qcplay.com/h5-images/active/ares/anniversary/img_mucai_number.png")`
      coin.style.backgroundSize = 'contain';
      coin.style.backgroundRepeat = 'no-repeat';
      coin.style.opacity = '1';
      coin.style.transition = 'transform 1.2s ease-in-out, opacity 1.2s';

      // 插入页面
      document.body.appendChild(coin);

      // 强制 reflow（确认样式已经生效）
      coin.getBoundingClientRect(); // 关键 ✔️

      // 计算偏移目标
      const deltaX = endX - startX;
      const deltaY = endY - startY;

      // 设置 transform 触发动画
      coin.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.5)`;
      coin.style.opacity = '0';

      // 动画完成移除 DOM
      setTimeout(() => {
        coin.remove();
        this.collectting = false
      }, 1200);
    },
    collectAllCoins() {
      const endRect = document.querySelector('.left-top-box').getBoundingClientRect();
      document.querySelectorAll('.income-box').forEach(el => {
        const rect = el.getBoundingClientRect();
        this.flyCoin(rect.left, rect.top, endRect.left, endRect.top);
      });
      // 可以在这里触发「收割成功音效/逻辑」
      // this.playCollectSound();
    },
    handleCakeModalClose(type) {
      this.storyShow = true
      this.showCakeModal = false
      if (type !== 'back') {
        this.cameraMusic.play()
        this.photoShow = true
      }
      // 领取彩蛋奖励
      if (this.user_activity.story_progress[5].status === 1) {
        getStory({ story_id: 6 }).then((res) => {
          if (res.code === 200) {
            this.storyRewardShow = true
            this.playGotMusic()
            this.getLoginContainer()
          } else {
            this.tipsMessage(res.message)
          }
        })
      }
    },
    triggerNpcLine(npcId) {
      if (this.isSpeaking || this.isCoolingDown) return;
      const npc = this.npcList.find(n => n.id === npcId);
      if (!npc) return;
      const lines = this.npcLines[npc.name];
      if (!lines || lines.length === 0) return;
      const randomLine = lines[Math.floor(Math.random() * lines.length)];
      this.currentNpcId = npcId;
      this.currentLine = randomLine;
      this.isSpeaking = true;
      // 台词显示 2 秒
      setTimeout(() => {
        this.closeLine();
      }, 2000);
    },
    closeLine() {
      this.isSpeaking = false;
      this.currentNpcId = null;
      this.currentLine = '';
      this.isCoolingDown = true;
      setTimeout(() => {
        this.isCoolingDown = false;
        // 可在此处再次自动触发下一个人说话
        const allIds = this.npcList.map(n => n.id);
        const randomNpcId = allIds[Math.floor(Math.random() * allIds.length)];
        this.triggerNpcLine(randomNpcId)
      }, 5000);
    },
    shuffleNpcOnPaths() {
      let routes = [
        { class: 'path-1', animation: 'top-right' },
        { class: 'path-2', animation: 'left-top' },
        { class: 'path-3', animation: 'center-bottom' },
      ];
      // 所有 NPC
      const npcs = [...this.allNpcs];

      // 随机打乱
      const shuffled = npcs.sort(() => Math.random() - 0.5);

      // 分配前3个角色绑定在 3 条路径上
      this.npcList = routes.map((route, index) => {
        const npc = shuffled[index];
        return {
          id: npc.id,
          name: npc.name,
          class: npc.name + ' ' + route.animation
          // class 将变成例如： "hante top-tight"
        };
      });
    },
    handleConfirmAddress() {
      this.playClickMusic()
      if (!this.name) {
        this.addressTipsMessage('请填写收件人姓名', 1000)
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.addressTipsMessage('请填写正确的手机号', 1000)
        return
      }
      if (!this.selected || this.selected.length < 3) {
        this.addressTipsMessage('请选择所在地区', 1000)
        return
      }
      if (!this.address) {
        this.addressTipsMessage('请填写详细地址', 1000)
        return
      }
      submitAddress({ province: this.province, city: this.city, country: this.country, address: this.address, phone: this.phone, name: this.name }).then((res) => {
        if (res.code === 200) {
          this.addressTipsMessage('填写成功', 1000)
          this.addressShow = false
        } else {
          this.addressTipsMessage(res.message)
        }
      })
    },
    handleChangeAccount() {
      this.playClickMusic()
      this.logout()
    },
    showRewardDetail(index) {
      if (index === 5) return
      this.rewardDetail = index + 1;
      this.drawRewardDetailShow = true
    },
    handleDrawResultClose() {
      this.playClickMusic()
      if (this.drawResultId === 1) {
        this.addressShow = true
      }
      this.drawResultShow = false
    },
    handleRedTipClick() {
      this.photoShow = true
      this.showRedTip = false
      localStorage.setItem('redTip', 'showed')
      this.logger.sum('周年庆_合影功能')
    },
    handleNpcAvatarClick(id) {
      this.npcId = id
      let npcIds = JSON.parse(localStorage.getItem('npcId') || '[]')
      if (npcIds.includes(id)) {
        this.npcConfirmShow = true
      } else {
        npcIds.push(id)
        localStorage.setItem('npcId', JSON.stringify(npcIds))
        this.handleNpcConfirm(true)
      }
    },
    handleNpcConfirm(hideMusic) {
      if (!hideMusic) {
        this.playClickMusic()
      }
      this.building_id = 0
      this.unlockDialogue = this.allNpcDialogues[this.npcId]
      this.showUnlockDialogue = true
      this.npcConfirmShow = false
    },
    // 弹幕播报
    startTicker() {
      if (!this.notice || this.notice.length === 0) return;

      this.intervalTimer = setInterval(() => {
        if (this.notice.length === 1) {
          // 单条：模拟重新渲染触发动画
          this.keySeed += 1;
        } else {
          // 多条：下一个索引
          this.currentNoticeIndex =
            (this.currentNoticeIndex + 1) % this.notice.length;
          this.keySeed = this.currentNoticeIndex; // 设置 key
        }
      }, 4000); // 4秒一轮播
    },
    handleStoryDialogClose() {
      if (this.storyId) {
        getStory({ story_id: this.storyId }).then((res) => {
          this.storyShow = true
          this.showStoryDialogue = false
          if (res.code === 200) {
            this.storyRewardShow = true
            this.playGotMusic()
            this.getLoginContainer()
          } else {
            this.tipsMessage(res.message)
          }
        })
      } else {
        this.storyShow = true
        this.showStoryDialogue = false
      }
    },
    formatText(item) {
      const textArr = ['', '庆典舞台', '露天营地', '野炊小栈', '武器展台', '纪念摊位']
      return `${textArr[item.id]} ${item.current_level}/${item.level_limit} 级解锁`
    },
    onHandleAskHelpClick(level) {
      if ((level === 1 && this.user_activity.help_number === 0) || (level === 2 && this.user_activity.help_number < 3)) {
        this.playClickMusic()
        this.logger.sum('周年庆_邀请按钮')
        this.showHelp = true
      }
    },
    handleDialogClose() {
      if (this.building_id) {
        // 展示解锁弹窗
        this.currentBuilding = this.user_activity.building_list.find((item) => item.id === this.building_id) || {}
        this.showUnlockModal = true
        this.showUnlockDialogue = false
        const unlockRecords = JSON.parse(localStorage.getItem('roleUnlockRecords') || '{}')
        const roleId = this.user_userInfo.role_id
        const lockDialogueIds = unlockRecords[roleId] || []
        lockDialogueIds.push(this.building_id)
        unlockRecords[roleId] = lockDialogueIds
        localStorage.setItem('roleUnlockRecords', JSON.stringify(unlockRecords))
      } else if (this.npcId) {
        this.showUnlockDialogue = false
      }
    },
    onHandleLevelUpClick(id) {
      this.playClickMusic()
      this.building_id = id
      this.currentBuilding = this.user_activity.building_list.find((item) => item.id === id) || {}
      this.showLevelUpModal = true
    },
    onHandleLevelUp(level, type) {
      if (level === 1 && !this.currentBuilding.unlock) return
      if (level === 5 && !this.currentBuilding.five_unlock) return
      this.playClickMusic()
      buildingUp({ building_id: this.building_id, type: level }).then(async (res) => {
        if (res.code === 200) {
          if (type === 'unlock') {
            this.showUnlockModal = false
            this.playBuildMusic()
            this.logger.sum('周年庆_解锁建筑')
            this.tipsMessage(`解锁${this.areaName[this.building_id]}成功`)
          } else if (type === 'level-up') {
            const from = this.currentBuilding.level || 1
            const to = res.data.level

            let shouldPlayMusic = false

            for (let lvl = from + 1; lvl <= to; lvl++) {
              if (lvl % 10 === 0 && lvl <= 100) {
                shouldPlayMusic = true
                break
              }
            }
            if (shouldPlayMusic) {
              this.playBuildMusic()
            }
            this.logger.sum('周年庆_升级建筑')
            this.tipsMessage('升级成功', 1000)
          }
          const response = await this.getLoginContainer()
          if (response.code === 200) {
            this.currentBuilding = response.data.activity.building_list.find((item) => item.id === this.building_id) || {}
          }
        } else {
          this.tipsMessage(res.message)
        }
      })
    },
    updateIncome(time) {
      const building_list = this.user_activity.building_list || []
      building_list.forEach((item) => {
        const i = item.id
        // 0表示重置
        const total = time === 0 ? 0 : (this[`income${i}`] + (item.produce * (1 + (this.user_activity.crit_rate / 100))) * time)
        let formatTotal = total
        if (total >= 1000 && total < 1000000) {
          formatTotal = Math.floor(total / 1000) + "K";
        } else if (total >= 1000000 && total < 1000000000) {
          formatTotal = Math.floor(total / 1000000) + "M";
        } else if (total >= 1000000000 && total < 1000000000000) {
          formatTotal = Math.floor(total / 1000000000) + "G";
        } else if (total >= 1000000000000 && total < 1000000000000000) {
          formatTotal = Math.floor(total / 1000000000000) + "T";
        } else if (total >= 1000000000000000) {
          formatTotal = Math.floor(total / 1000000000000000) + "P";
        }
        this[`income${i}`] = total
        this[`formatIncome${i}`] = formatTotal
      })
    },
    getLevelStageClass(id, needText) {
      const building_list = this.user_activity.building_list || []
      const building = building_list.find((item) => item.id === id) || {}
      const level = building.level || 0
      const perStage = 10
      let stage = 0;
      if (needText) {
        return `等级: LV.${level}`
      }
      if (level > 0) {
        stage = Math.min(Math.floor(level / perStage) + 1, 11);
      }
      const classes = [`level-stage-${stage}`];
      if (level >= 1) {
        classes.push('has-level');
      }
      return classes;
    },
    removeInviteCodeFromURL() {
      const url = new URL(window.location.href);
      url.searchParams.delete('invite_code');
      window.history.replaceState({}, '', url.toString());
    },
    handleNoNeedClose() {
      this.removeInviteCodeFromURL()
      this.showNoNeedHelp = false
    },
    handleHelpFailClose() {
      this.removeInviteCodeFromURL()
      this.showHelpFail = false
    },
    handleHelpMeColse() {
      this.removeInviteCodeFromURL()
      this.showHelpMe = false
    },
    onHandleHelpClick() {
      this.playClickMusic()
      const params = analysisParams(window.location.href);
      const { invite_code } = params;
      invite({ invite_code }).then((res) => {
        if (res.code === 200) {
          this.tipsMessage('协助成功')
          this.removeInviteCodeFromURL()
        } else if (res.code === 404) {
          this.showNoNeedHelp = true // 帮手已足够
        } else if (res.code === 403) {
          this.showHelpMe = true // 不能助力自己
        } else if (res.code === 405) {
          this.showHelpFail = true // 已经帮助过
        } else {
          this.tipsMessage(res.message) // 其他情况
        }
        this.helpShow = false
      })
    },
    onHandleDownload() {
      this.playClickMusic()
      const isWechat = wechatBrowser()
      this.logger.sum('周年庆_下载游戏')
      if (isWechat) {
        // this.wxLoadShow = true
        const params = analysisParams(window.location.href);
        const { download_id, title } = params;
        window.location.href = `https://h5.qingcigame.com/ares/anniversary/download?title=${title}&download_id=${download_id}`
      } else {
        const linkObj = this.downloadUrls
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i)
        const targetLink = isIOS ? linkObj.ios_url : linkObj.android_url
        if (targetLink) {
          setTimeout(() => {
            window.location.href = targetLink
          }, 200)
        }
      }
    },
    onGetDrawTotalClick(item) {
      if (item.status === 1) {
        this.drawResultId = 0
        getCumulative({ cumulative_id: item.id }).then((res) => {
          if (res.code === 200) {
            this.drawResultId = item.id + 10
            this.drawResultShow = true
            this.playGotMusic()
            this.getLoginContainer()
          } else {
            this.tipsMessage(res.message)
          }
        })
      } else {
        this.rewardDetail = item.id + 10
        this.drawRewardDetailShow = true
      }
    },
    // 角色气泡点击
    handleBubbleClick(role) {
      this.tipsMessage('点击气泡')
      console.log('点击气泡', role.getData('name'))
    },
    playGotMusic() {
      this.getMusic && this.getMusic.play()
    },
    async startDraw() {
      this.playClickMusic()
      if (!this.user_activity.judge_draw) {
        this.storyShow = true
        this.drawShow = false
        this.logger.sum('周年庆_立即前往故事')
        return
      }
      if (this.spinning) return; // 防止连点
      if (this.user_activity.draw_number <= 0) {
        this.tipsMessage('抽奖次数不足', 1000)
        return
      }
      this.logger.sum('周年庆_抽取一次')
      this.spinning = true;
      this.preventShow = true;

      const prizeCount = 9;             // 奖项数量
      const fullCircles = 8;            // 动画转几圈
      const duration = 3000;            // 动画持续时间（ms）
      const baseAngle = 360 / prizeCount;
      const initial = this.angle || 0;
      this.drawResultId = 0
      try {
        // 1. 向后端请求中奖结果
        const response = await draw(); // draw() 是 API 接口
        if (response.code !== 200) {
          this.tipsMessage(response.message)
          this.spinning = false;
          this.preventShow = false;
          return
        }

        const { id, cumulative_draw, cumulative_progress, record } = response.data; // 假设返回 0 ~ 8 的 index
        const prop_list = this.user_activity.prop_list || []

        const targetIndex = prop_list.findIndex((item) => item.id === id);

        const targetAngle = 360 * fullCircles + (targetIndex * baseAngle + baseAngle / 2);
        // 2. 执行动画
        this.user_activity.draw_number = this.user_activity.draw_number - 1
        const start = performance.now();
        const animate = (time) => {
          const elapsed = time - start;

          if (elapsed < duration) {
            const progress = elapsed / duration;
            const easeOut = 1 - Math.pow(1 - progress, 3); // easeOutCubic
            this.angle = initial + (targetAngle - initial) * easeOut;
            requestAnimationFrame(animate);
          } else {
            // 3. 动画结束，转盘落点
            this.angle = targetAngle % 360;
            this.spinning = false;
            this.preventShow = false;
            if (id === 6) {
              this.tipsMessage(response.data.name);
            } else {
              this.drawResultId = id
              this.drawResultShow = true
              this.playGotMusic()
            }
            // 4. 重新拉去数据（假设有剩次数）
            this.cumulative_draw = cumulative_draw || 0
            this.user_activity.record.draw_record = record.draw_record
            this.cumulative_progress = this.cumulative_progress.map((item) => {
              const obj = cumulative_progress.find((j) => j.id === item.id)
              return {
                ...item,
                status: obj.status
              }
            })
          }
        };

        requestAnimationFrame(animate);
      } catch (err) {
        console.error('抽奖失败:', err);
        this.spinning = false;
        this.preventShow = false;
        this.tipsMessage('网络错误，请稍后重试');
      }
    },
    getDrawInfoList() {
      drawBigInfo().then((res) => {
        this.notice = res.data.notify || []
        this.startTicker();
      })
    },
    openAddressShow() {
      this.addressShow = true;
      this.playClickMusic();
      console.log('点击填写地址');
    },
    onHandleTaskClick(item) {
      if (item.status === 0 && item.link) {
        this.playClickMusic()
        if (item.id === 3) {
          window.location.href = item.link
          return
        }
        Indicator.open();
        finishTask({ task_id: item.id }).then((res) => {
          Indicator.close();
          if (res.code === 200) {
            this.user_activity.task_list = res.data.task
            window.location.href = item.link
          } else {
            this.tipsMessage(res.message, 1000)
          }
        })
      } else if (item.status === 1) {
        this.playClickMusic()
        if (item.id === 2) {
          this.logger.sum('周年庆_关注官微奖励领取')
        } else if (item.id === 3) {
          this.logger.sum('周年庆_添加企微奖励领取')
        } else if (item.id === 4) {
          this.logger.sum('周年庆_给予鼓励奖励领取')
        } else if (item.id === 5) {
          this.logger.sum('周年庆_参与论坛活动奖励领取')
        }
        getTaskReward({ task_id: item.id }).then((res) => {
          if (res.code === 200) {
            this.tipsMessage('领取成功', 1000)
            this.getLoginContainer()
          } else {
            this.tipsMessage(res.message)
          }
        })
      }
    },
    onHandleAreaClick(id) {
      const area = this.user_activity.building_list.find((item) => item.id === id) || {}
      if (area.lock) {
        // 解锁对话
        this.building_id = id

        // 对话看过了就不看了
        const unlockRecords = JSON.parse(localStorage.getItem('roleUnlockRecords') || '{}')
        const roleId = this.user_userInfo.role_id
        const lockDialogueIds = unlockRecords[roleId] || []
        if (!lockDialogueIds.includes(id)) {
          this.unlockDialogue = this.allUnlockDialogues[id]
          this.showUnlockDialogue = true
        } else {
          this.currentBuilding = this.user_activity.building_list.find((item) => item.id === id) || {}
          this.showUnlockModal = true
        }
      }
    },
    onHandleDrawClick() {
      this.angle = 0
      this.playClickMusic()
      this.drawShow = true
    },
    onHandleDetailClick() {
      this.logger.sum('周年庆_活动说明')
      this.playClickMusic()
      this.detailShow = true
    },
    onHandlestoryClick() {
      this.playClickMusic()
      this.storyShow = true
    },
    onHandleConfigClick() {
      this.playClickMusic()
      this.configShow = true
    },
    onHandleShareClick() {
      this.playClickMusic()
      this.logger.sum('周年庆_分享按钮')
      this.shareShow = true
    },
    onHandleUndoClick() {
      this.playClickMusic()
      this.undoShow = true
    },
    onHandleAddressFill() {
      this.addressShow = true
    },
    playClickMusic() {
      this.clickMusic && this.clickMusic.play()
    },
    playBuildMusic() {
      this.buildMusic && this.buildMusic.play()
    },
    onHandleGetClick() {
      this.playClickMusic()
      if (!this.user_userInfo.role_id) {
        this.loginMiddleShow = true
        return
      }
      if (this.user_activity.building_list.find((item) => item.lock === 0)) {
        if (this.collectting) return
        this.collectting = true
        income({ type: 1 }).then(async (res) => {
          if (res.code === 200) {
            this.collectAllCoins()
            const building_list = this.user_activity.building_list || []
            building_list.forEach((item) => {
              const i = item.id
              this[`income${i}`] = 0
              this[`formatIncome${i}`] = 0
            })
            this.user_activity.gold_coin = res.data.gold_coin
            const response = await this.getLoginContainer()
            if (response.code === 200) {
              this.incomeTimer = setInterval(() => {
                this.updateIncome(5);
              }, 5000);
            }
            this.collectting = false
          } else {
            this.tipsMessage(res.message)
            this.collectting = false
          }
        }).catch(() => {
          this.collectting = false
        })
      }
    },
    onStoryClick(item) {
      const id = item.id
      this.introText = `忙碌了这么久\n【${this.areaName[id]}】可算准备完成了\n得好好感谢【${this.helpName[id]}】...`
      this.storyDialogue = this.allStoryDialogues[id]
      if (item.status === 1) {
        this.playClickMusic()
        this.storyId = id
        if (item.id === 6) {
          this.storyShow = false
          this.showCakeModal = true
          this.hasEnteredBefore = false
          return
        }
        this.hasEnteredBefore = false
        this.showStoryDialogue = true
        this.storyShow = false
      } else if (item.status === 2) {
        this.playClickMusic()
        this.storyId = 0
        if (item.id === 6) {
          this.storyShow = false
          this.showCakeModal = true
          this.hasEnteredBefore = true
          return
        }
        this.hasEnteredBefore = true
        this.showStoryDialogue = true
        this.storyShow = false
      }
    },
    onCityConfirm(e) {
      console.log('e', e)
      const { province, county, city } = e
      this.province = province
      this.city = city
      this.country = county
      this.selected = province + ' ' + city + ' ' + county
    },
    // 适配
    forceLandscapeScreenHandle() {
      const activeEl = document.activeElement || {};
      const tagName = activeEl.tagName && activeEl.tagName.toLowerCase();
      const isEditable = activeEl.isContentEditable === true;
      if (['input', 'textarea', 'select'].includes(tagName) || isEditable) {
        return;
      }

      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      var docEl = document.documentElement,
        fontH = window.innerWidth > window.innerHeight ? height : width;

      const el = document.getElementById("main-container");
      let style = "";
      if (width < height) {
        // 竖版
        style = `transform:rotate(90deg);transform-origin:${
          width / 2
          }px center;width:${height}px;height:${width}px`;
        this.onAdapt(1);
      } else {
        // 横板
        setTimeout(() => {
          document.documentElement.style.fontSize = (75 * fontH) / 750 + "px";
          style = `transform:rotate(0deg);transform-origin:${
            width / 2
            }px center;width:${width}px;height:${height}px`;
          if (el) el.style = style;
        }, 300);
        this.onAdapt(2);
      }
      this.isPC = window.innerWidth >= 1024 || window.screen.width >= 1024;

      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      // 设置一个状态锁，表示用户正在调整大小，不要切换游戏
      this.resizePending = true;
      this.resizeTimer = setTimeout(() => {
        if (this.resizePending) {
          this.resizePending = false;
          console.log('改变大小了')
          // this.initBg();
        }
      }, 300);
      // document.getElementsByTagName(
      //   "body"
      // )[0].style = `width:${width}px;height:${height}px;font-size:${
      //   (75 * fontH) / 750
      //   }px;`;
      if (el) el.style = style;
    },
    onWindowSizeChanged() {
      window.addEventListener("resize", this.forceLandscapeScreenHandle);
    },
    isReloadWindow(event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance &&
            window.performance.navigation &&
            window.performance.navigation.type === 2))
      );
    },
    startLoading() {
      // 防止第二次进入 微信底部有一个返回条，造成布局问题
      if (this.isReloadWindow()) {
        window.location.reload();
        return;
      }
    },
    //小屏自适应 type 1竖屏 2横屏
    onAdapt(type) {
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      const aspectRatio = Number((width / height).toFixed(3));
      console.log("aspectRatio", aspectRatio);
      // 竖屏大于0.6就要缩小0.83
      // 横屏小于1.7就要缩小 1.48缩小0.85 1.3缩小0.75  大于2.16就是横屏太长，换背景
      if (type == 1) {
        this.isLong = false;
        if (aspectRatio >= 0.63) {
          this.scaleStyle = "transform-origin: right;transform: scale(0.83);";
        } else {
          this.scaleStyle = "transform-origin: right;transform: scale(1);";
        }
      } else {
        if (aspectRatio < 1.7 && aspectRatio >= 1.48) {
          this.scaleStyle = "transform-origin: right;transform: scale(0.85);";
          this.isLong = false;
        } else if (aspectRatio < 1.48 && aspectRatio >= 1.3) {
          this.scaleStyle = "transform-origin: right;transform: scale(0.75);";
          this.isLong = false;
        } else if (aspectRatio > 2.16) {
          this.scaleStyle = "transform-origin: right;transform: scale(1);";
          this.isLong = true;
        } else {
          this.scaleStyle = "transform-origin: right;transform: scale(1);";
          this.isLong = false;
        }
      }
    },
    // 初始化
    async getLoginContainer() {
      // Indicator.open();
      try {
        this.shuffleNpcOnPaths()
        setInterval(() => {
          this.shuffleNpcOnPaths()
        }, 24000); // 每轮20秒
        // this.npcList = this.allNpcs
        setInterval(() => {
          if (!this.isSpeaking && !this.isCoolingDown) {
            const allIds = this.npcList.map(n => n.id);
            const npcId = allIds[Math.floor(Math.random() * allIds.length)];
            this.triggerNpcLine(npcId);
          }
        }, 6000); // 每轮 6 秒尝试说话
        const response = await onGetInitDataAPI();
        if (Number(response.code) == 200) {
          const { user_info, activity } = response.data
          const { name, phone, province, city, country, address } = activity || {}
          this.user_activity = activity;
          this.user_userInfo = user_info;
          this.cumulative_draw = activity.cumulative_draw
          this.cumulative_progress = this.cumulative_progress.map((item) => {
            const obj = activity.cumulative_progress.find((j) => j.id === item.id)
            return {
              ...item,
              status: obj.status
            }
          })
          this.name = name
          this.phone = phone
          this.province = province
          this.city = city
          this.country = country
          this.address = address
          this.selected = province + ' ' + city + ' ' + country
          // 回来第一次初始化要展示离线收益
          if (!this.isInited && activity.income) {
            this.gobackShow = true
          }
          if (this.incomeTimer) {
            clearInterval(this.incomeTimer);
            this.incomeTimer = null
          }
          if (!this.isInited) {
            this.updateIncome(0); // 先全部置为0（切换账号也是一样）
            // 每5秒更新一次金币显示
            this.incomeTimer = setInterval(() => {
              this.updateIncome(5);
            }, 5000);
          }
          // 是否展示获得buff加成
          let buff1Ids = JSON.parse(localStorage.getItem('showBuff1Ids') || '[]')
          let buff2Ids = JSON.parse(localStorage.getItem('showBuff2Ids') || '[]')
          if (!buff1Ids.includes(user_info.role_id) && activity.crit_rate === 50) {
            this.showBuff = true
            this.buffType = 1
            buff1Ids.push(user_info.role_id)
            localStorage.setItem('showBuff1Ids', JSON.stringify(buff1Ids))
          }
          if (!buff2Ids.includes(user_info.role_id) && activity.crit_rate === 200) {
            this.showBuff = true
            this.buffType = 2
            buff2Ids.push(user_info.role_id)
            localStorage.setItem('showBuff2Ids', JSON.stringify(buff2Ids))
          }
          this.shareLink = `https://h5.qingcigame.com/ares/anniversary/enter?invite_code=${activity.invite_code}`;
          setTimeout(() => {
            this.initShareData();
          }, 500);
          this.isInited = true
          // 完成彩蛋，直接切换为欢快音乐
          if (activity.story_progress[5].status === 2 && this.currentBgmType !== 'happy') {
            // 切换到欢快音乐
            this.switchBgmTo('happy');
          }

          if (activity.story_progress[5].status !== 2 && this.currentBgmType !== 'relaxed') {
            // 切回轻松音乐
            this.switchBgmTo('relaxed');
          }
          this.topLeftUI && this.topLeftUI.txtMucai.setText(activity.gold_coin)
          this.topLeftUI && this.topLeftUI.txtIncome.setText(`${activity.speed_produce}/秒`)
          this.topLeftUI && this.topLeftUI.txtDraw.setText(activity.draw_number)
          // this.onInitDataCallback(response);
          this.setUserInfo(user_info);
          return response;
        } else if (Number(response.code) == 401) {
          this.onInitDataCallback({ ...response, needAccount: false });
          // 没有登录的话弹出登录中间页
          this.loginMiddleShow = true
          return response;
        } else {
          this.loginMiddleShow = true
          this.tipsMessage('初始化错误')
          return response;
        }
      } catch (err) {
        console.log('err', err)
      } finally {
        Indicator.close();
      }
    },

    // 获取分享奖励
    getShareReward() {
      if (this.user_activity.is_share) {
        return;
      }
    },
    // 关闭分享截图弹窗
    shareShowClick() {
      this.shareShow = false;
      if (this.isShare) {
        this.$refs.dialogRef.isShowShareSuccess = true;
        this.isShare = false;
      }
    },
    // 长按 - 点击按钮
    onTouchStart() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        // 长按触发的操作
        this.getShareReward();
      }, 500);
    },
    onTouchEnd() {
      // 手指离开时清除定时器
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    // 打开选择标签弹窗
    isShowTapDialog() {
      this.$refs.dialogRef.isShowTapDialog = true;
    },
    // 背景音乐点击事件
    musicClick(value) {
      this.playClickMusic()
      if (value) {
        this.isShowMusicBtn = false;
        this.bgMusic.stop();
      } else {
        this.isShowMusicBtn = true;
        this.bgMusic.play();
      }
    },
    // 打开活动详情弹窗
    isShowActivityDetailDialog() {
      this.$refs.dialogRef.isShowActivityDetail = true;
    },
    // 打开分享报告弹窗
    isShowShareDialog() {
      if (this.user_activity.play_info == 0) {
        this.$refs.dialogRef.isShowShareDialog1 = true;
      } else {
        this.$refs.dialogRef.isShowShareDialog = true;
      }
    },
    // 打开保存分享图片弹窗
    isShowShareImg() {
      this.$refs.dialogRef.isShowShareDialog = false;
      this.$refs.dialogRef.isShowShareDialog1 = false;
      this.shareShow = true;
    },
    // 初始化分享信息
    initShareData() {
      try {
        this.qrcode(`${this.shareLink}`);
        this.$nextTick(() => {
          this.generateShareImage();
        });
      } catch (err) {
        // 错误信息
        console.log("err", err);
      }
    },
    qrcode(link) {
      generateQRCode(document.getElementById("qrcode"), {
        text: link,
        colorDark: "#837E9C",
        // colorDark: "#000",
        colorLight: "#FFF",
      })
    },
    // 分享图片设置
    generateShareImage() {
      generateCanvasImage(
        this.$refs.imageDom
      )
        .then((canvas) => {
          this.shareImg = canvas.toDataURL("image/png"); // 可将 canvas 转为 base64 格式
        })
        .catch((err) => {
          console.log("err: 图片生成失败", err.message);
        })
    },
    // 复制链接
    onCopy(copyname, tip) {
      this.playClickMusic()
      const clipboard = new Clipboard(copyname);
      clipboard.on("success", (e) => {
        this.tipsMessage(tip ? tip : "已成功复制链接");
        this.showHelp = false
        this.shareShow = false
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.tipsMessage("复制失败");
      });
    },
    // 复制单号
    onAddressCopy(copyname) {
      const clipboard = new Clipboard(copyname);
      clipboard.on("success", (e) => {
        this.addressTipsMessage("已成功复制单号");
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        // this.addressTipsMessage("复制失败");
      });
    },
    // 退出登录
    logout() {
      onLogoutAPI({ game_id: 41 }).then((res) => {
        if (res.code === 200) {
          // 清空数据 控制弹窗
          this.configShow = false
          window.localStorage.setItem("access_token", "");
          this.user_activity = {};
          this.user_userInfo = {};
          this.cumulative_draw = 0
          this.cumulative_progress = this.cumulative_progress.map((item) => {
            return {
              ...item,
              status: 0
            }
          })
          if (this.incomeTimer) {
            clearInterval(this.incomeTimer);
            this.incomeTimer = null
          }
          this.isInited = false
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.loginMiddleShow = true
        } else {
          this.tipsMessage(res.message, 2000);
        }
      });
    },
    selectCallback() {
      this.loginMiddleShow = false
      this.getLoginContainer();
    },
    osCancell() {
      // 清空数据
      this.getLoginContainer();
    },
    tipsMessage(message, times = 2000) {
      this.tipsShow = true;
      this.tips = message;
      setTimeout(() => {
        this.tipsShow2 = true;
      }, 100);
      setTimeout(() => {
        this.tipsShow2 = false;
      }, times - 200);
      setTimeout(() => {
        this.tipsShow = false;
        this.tips = "";
      }, times);
    },
    addressTipsMessage(message, times = 2000) {
      this.addressTipsShow = true;
      this.addressTips = message;
      setTimeout(() => {
        this.addressTipsShow2 = true;
      }, 100);
      setTimeout(() => {
        this.addressTipsShow2 = false;
      }, times - 200);
      setTimeout(() => {
        this.addressTipsShow = false;
        this.addressTips = "";
      }, times);
    },
    // 打开登陆弹窗
    openLoginOS() {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
      } else {
        this.logoutShow = true;
      }
    },
    noRole() {
      const params = analysisParams(window.location.href);
      const { invite_code } = params;
      if (invite_code) {
        this.noRoleShow = true
      } else {
        this.commonNoRoleShow = true
      }
    },
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/ares/anniversary/enter${getTimeStamp()}`,
        title: "镇长，庆典筹备就靠你了！",
        imgUrl:
          "https://download4.qcplay.com/qcgame-admin/RHXbBWlkBWUaAEAIDvryrq4xand7DStqLiS4m0fZ.png",
        desc: "在？这次周年没你真不行，1年月卡、1周年神秘礼、游园币等豪礼已备好，速来搭建周年庆场地，福利管够！",
      });
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/ares/anniversary/index/index.vue